(() => {
  if (window.EverSilkyPricingLoaded) return;
  window.EverSilkyPricingLoaded = true;
  const DEFAULT_SETTINGS = {
    dataUrl: null,
    exchangeRate: 6.92,
    markupCustomWig: 1.4,
    markupBundlesTier1: 1.55,
    markupBundlesTier2: 1.45,
    markupBundlesTier3: 1.35,
    markupFrontalsNatural: 1.5,
    markupFrontals613: 1.63,
    markupFullLace: 1.7,
    markupIntegrated: 1.2,
    customWigFee: 8,
    bleachKnotFee: 5,
    shippingTier1Threshold: 215,
    shippingFeeTier1: 42,
    shippingTier2Threshold: 440,
    shippingFeeTier2: 25,
    globalDiscountAdjustment: 0,
    whatsappPhone: '',
    cartVariantId: '',
    maxQuantity: 99,
    pageType: '',
    productTitle: '',
    productCollectionHandles: [],
    entryPoint: 'auto',
    homepageHandles: '',
    bestSellersHandles: '',
    galleryStyleHandles: '',
    galleryColorHandles: '',
    galleryTypeHandles: '',
    hdFrontalsHandles: '',
    bundlesHandles: ''
  };

  const PRODUCT_TYPE_ORDER = [
    'custom_bundle_wig',
    'hair_bundles_only',
    'frontals_only',
    'full_lace'
  ];

  const REMOVED_PRODUCT_TYPES = new Set(['budget_series']);
  const QUOTE_FIXED_PRODUCT_TYPE = 'custom_bundle_wig';

  const FIELD_ORDER = [
    'product_type',
    'construction_type',
    'color',
    'lace',
    'frontal_size',
    'length',
    'density',
    'texture',
    'cap_type',
    'cap_size'
  ];

  const WHATSAPP_SEPARATOR_DESKTOP = '..........................';
  const WHATSAPP_SEPARATOR_MOBILE = '...................';
  const WHATSAPP_MOBILE_BREAKPOINT = 760;

  const OPTION_GROUP_MAP = {
    product_type: 'product_type',
    construction_type: 'construction_type',
    color: 'color',
    lace: 'lace',
    length: 'length',
    frontal_size: 'frontal_size',
    density: 'density',
    texture: 'texture',
    cap_type: 'cap_type',
    cap_size: 'cap_size'
  };

  const ENTRY_QUERY_KEYS = ['entry', 'calc_entry', 'calculator_entry', 'gallery', 'gallery_type', 'calc_view'];

  const ENTRY_PROFILES = {
    homepage: {
      id: 'homepage',
      label: 'Homepage',
      enabledProductTypes: [...PRODUCT_TYPE_ORDER]
    },
    best_sellers: {
      id: 'best_sellers',
      label: 'Best Sellers',
      enabledProductTypes: ['custom_bundle_wig', 'full_lace']
    },
    bundles: {
      id: 'bundles',
      label: 'Gallery Bundles',
      enabledProductTypes: ['hair_bundles_only']
    },
    frontals: {
      id: 'frontals',
      label: 'Gallery Frontals',
      enabledProductTypes: ['frontals_only']
    },
    style_type_color: {
      id: 'style_type_color',
      label: 'Gallery Style/Type/Color',
      enabledProductTypes: ['custom_bundle_wig', 'full_lace']
    }
  };

  const PRODUCT_FIELD_FLOWS = {
    custom_bundle_wig: ['product_type', 'construction_type', 'color', 'lace', 'frontal_size', 'length', 'density', 'texture', 'cap_type', 'cap_size'],
    hair_bundles_only: ['product_type', 'color', 'length', 'texture'],
    frontals_only: ['product_type', 'color', 'lace', 'frontal_size', 'length', 'texture'],
    full_lace: ['product_type', 'color', 'lace', 'length', 'density', 'texture', 'cap_type', 'cap_size']
  };

  const QUOTE_PARAM_MAP = {
    construction: {
      assembled: 'assembled',
      assembledconstruction: 'assembled',
      integrated: 'integrated',
      integratedonepiece: 'integrated',
      integratedonepiececonstruction: 'integrated'
    },
    constructiontype: {
      assembled: 'assembled',
      assembledconstruction: 'assembled',
      integrated: 'integrated',
      integratedonepiece: 'integrated',
      integratedonepiececonstruction: 'integrated'
    },
    color: {
      natural: 'natural_color',
      naturalcolor: 'natural_color',
      '613': '613',
      darksolid: 'dark_solid',
      dark_solid: 'dark_solid',
      lightsolid: 'light_solid',
      light_solid: 'light_solid',
      ombre: 'two_tone_ombre',
      twotoneombre: 'two_tone_ombre',
      two_tone_ombre: 'two_tone_ombre'
    },
    lacetype: {
      hdlace: 'hd_lace',
      hd_lace: 'hd_lace',
      transparentlace: 'transparent_lace',
      transparent_lace: 'transparent_lace'
    },
    wiglength: {
      8: '8',
      10: '10',
      12: '12',
      14: '14',
      16: '16',
      18: '18',
      20: '20',
      22: '22',
      24: '24',
      26: '26',
      28: '28',
      30: '30'
    },
    integratedlength: {
      '12-14': '12+14',
      '14-16': '14+16',
      '16-18': '16+18',
      '18-20': '18+20',
      '20-22': '20+22',
      '20-24': '20+24',
      '20-26': '20+26',
      '20-28': '20+28',
      '22-24': '22+24'
    },
    frontals: {
      '2x6': '2x6',
      '4x4': '4x4',
      '5x5': '5x5',
      '6x6': '6x6',
      '7x7': '7x7',
      '13x4': '13x4',
      '13x6': '13x6',
      360: '360_lace_frontal',
      '360lacefrontal': '360_lace_frontal',
      '360_lace_frontal': '360_lace_frontal'
    },
    density: {
      150: '150',
      180: '180',
      200: '200',
      250: '250'
    },
    texture: {
      st: 'natural_straight',
      straight: 'natural_straight',
      naturalstraight: 'natural_straight',
      natural_straight: 'natural_straight',
      bonestraight: 'bone_straight',
      bone_straight: 'bone_straight',
      bodywave: 'bw',
      loosebodywave: 'lbw',
      naturalwave: 'nw',
      loosewave: 'lw',
      deepwave: 'dw',
      jerrycurl: 'jc',
      loosebob: 'lb',
      loosedeep: 'ld',
      waterwave: 'ww',
      deepcurl: 'dc',
      italiancurl: 'ic',
      looseitaliancurl: 'lic',
      kinkycurl: 'kc',
      kinkystraight: 'kks',
      yaki: 'yaki',
      curly: 'curly'
    },
    captype: {
      glueless: 'glueless',
      gluedown: 'glue_down',
      'glue-down': 'glue_down',
      glue_down: 'glue_down'
    },
    capsize: {
      21: '21',
      '21.5': '21_5',
      '21_5': '21_5',
      22: '22_standard',
      '22standard': '22_standard',
      '22_standard': '22_standard',
      '22.5': '22_5',
      '22_5': '22_5'
    }
  };

  const QUOTE_PARAM_FIELDS = {
    product: 'product_type',
    producttype: 'product_type',
    construction: 'construction_type',
    constructiontype: 'construction_type',
    color: 'color',
    lace: 'lace',
    lacetype: 'lace',
    length: 'length',
    wiglength: 'length',
    integratedlength: 'length',
    frontal: 'frontal_size',
    frontals: 'frontal_size',
    frontalsize: 'frontal_size',
    density: 'density',
    texture: 'texture',
    captype: 'cap_type',
    installationmethod: 'cap_type',
    capsize: 'cap_size'
  };

  const CUSTOM_WIG_DISABLED_DENSITIES = new Set(['130']);
  const FULL_LACE_DISABLED_DENSITIES = new Set(['200']);

  function toNumber(value, fallback = 0) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function toInt(value, fallback = 0) {
    return Math.trunc(toNumber(value, fallback));
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function formatUsd(value) {
    const numeric = toNumber(value, 0);
    return `$${numeric.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })}`;
  }

  function formatPercent(value) {
    const numeric = toNumber(value, 0);
    if (Number.isInteger(numeric)) {
      return String(numeric);
    }
    return numeric.toFixed(2).replace(/\.?0+$/, '');
  }

  function formatWhatsAppUsd(value) {
    const numeric = toNumber(value, 0);
    return `$${numeric.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  }

  function normalizeWhatsAppLabel(value) {
    const normalized = String(value || 'N/A').trim();
    if (!normalized) {
      return 'N/A';
    }
    return normalized.replace(/_/g, ' ');
  }

  function normalizeWhatsAppColorLabel(value) {
    const normalized = normalizeWhatsAppLabel(value)
      .replace(/\s*\(Refer to the Color Showcase below\)\s*/i, '')
      .replace(/\s+\+\$\d+(?:\.\d+)?\s*$/i, '')
      .trim();

    if (normalized === 'Natural Color') {
      return 'Natural';
    }

    return normalized || 'N/A';
  }

  function formatWhatsAppLength(value, variant = 'headline') {
    const normalized = String(value || '').trim();
    if (!normalized || normalized === 'N/A') {
      return 'N/A';
    }

    const numeric = normalized.match(/^(\d+)(?:"|''?)?$/);
    if (numeric) {
      return variant === 'detail' ? `${numeric[1]}''` : `${numeric[1]}"`;
    }

    if (/\(Layered\)/i.test(normalized)) {
      return normalized;
    }

    if (variant === 'detail') {
      return normalized.replace(/"/g, "''");
    }

    return normalized.replace(/''/g, '"');
  }

  function getViewportWidth() {
    if (typeof window !== 'undefined' && typeof window.innerWidth === 'number' && window.innerWidth > 0) {
      return window.innerWidth;
    }
    if (typeof document !== 'undefined' && document.documentElement && document.documentElement.clientWidth > 0) {
      return document.documentElement.clientWidth;
    }
    return WHATSAPP_MOBILE_BREAKPOINT + 1;
  }

  function getWhatsAppSeparator() {
    return getViewportWidth() <= WHATSAPP_MOBILE_BREAKPOINT
      ? WHATSAPP_SEPARATOR_MOBILE
      : WHATSAPP_SEPARATOR_DESKTOP;
  }

  function normalizePhone(value) {
    return String(value || '').replace(/[^\d]/g, '');
  }

  function normalizePath(value) {
    const raw = String(value || '').trim().toLowerCase();
    if (!raw) {
      return '';
    }

    const cleaned = raw.split('#')[0].split('?')[0];
    const withLeadingSlash = cleaned.startsWith('/') ? cleaned : `/${cleaned}`;
    if (withLeadingSlash.length > 1 && withLeadingSlash.endsWith('/')) {
      return withLeadingSlash.slice(0, -1);
    }
    return withLeadingSlash;
  }

  function extractHandle(value) {
    const normalized = normalizePath(value);
    if (!normalized || normalized === '/') {
      return '';
    }

    const parts = normalized.split('/').filter(Boolean);
    return parts[parts.length - 1] || '';
  }

  function parsePathList(value) {
    return String(value || '')
      .split(/[\n,]/)
      .map((entry) => normalizePath(entry))
      .filter(Boolean);
  }

  function matchesConfiguredPath(entries, currentPath) {
    if (!entries.length) {
      return false;
    }

    const currentHandle = extractHandle(currentPath);
    return entries.some((entry) => {
      const entryHandle = extractHandle(entry);
      return entry === currentPath || (entryHandle && entryHandle === currentHandle);
    });
  }

  function isQuotePath(pathname) {
    const path = normalizePath(pathname);
    return path === '/pages/quote' || path === '/quote';
  }

  function normalizeQuoteParamValue(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/#/g, '')
      .replace(/[–—]/g, '-')
      .replace(/\s+/g, '');
  }

  function normalizeQuoteComparableValue(value) {
    return normalizeQuoteParamValue(value).replace(/[^a-z0-9.]+/g, '');
  }

  function normalizeQuoteParamKey(value) {
    return normalizeQuoteComparableValue(value).replace(/\./g, '');
  }

  function stripRemovedProductData(data) {
    if (!data || typeof data !== 'object') {
      return data;
    }

    if (data.meta && Array.isArray(data.meta.product_types)) {
      data.meta.product_types = data.meta.product_types.filter((item) => !REMOVED_PRODUCT_TYPES.has(item.id));
    }

    if (data.meta && data.meta.markup_defaults) {
      REMOVED_PRODUCT_TYPES.forEach((id) => {
        delete data.meta.markup_defaults[id];
      });
    }

    if (data.products) {
      REMOVED_PRODUCT_TYPES.forEach((id) => {
        delete data.products[id];
      });
    }

    return data;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getOptionById(options, id) {
    if (!Array.isArray(options)) {
      return null;
    }
    return options.find((option) => option.id === id) || null;
  }

  function isFiniteNumber(value) {
    return typeof value === 'number' && Number.isFinite(value);
  }

  function normalizeEntryPoint(raw) {
    if (!raw) {
      return 'auto';
    }

    const normalized = String(raw)
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');

    if (!normalized || normalized === 'auto') {
      return 'auto';
    }
    if (normalized === 'homepage' || normalized === 'home') {
      return 'homepage';
    }
    if (normalized === 'best_sellers' || normalized === 'best_seller' || normalized === 'bestseller') {
      return 'best_sellers';
    }
    if (normalized === 'bundles' || normalized === 'bundle' || normalized === 'gallery_bundles') {
      return 'bundles';
    }
    if (normalized === 'frontals' || normalized === 'frontal' || normalized === 'gallery_frontals') {
      return 'frontals';
    }
    if (
      normalized === 'style_type_color' ||
      normalized === 'style_type' ||
      normalized === 'style_type_colour' ||
      normalized === 'gallery_style_type_color'
    ) {
      return 'style_type_color';
    }

    return 'auto';
  }

  function parseHandleList(value) {
    if (Array.isArray(value)) {
      return value
        .map((entry) => extractHandle(entry))
        .filter(Boolean);
    }

    return parsePathList(value)
      .map((entry) => extractHandle(entry))
      .filter(Boolean);
  }


  function matchesConfiguredHandle(entries, collectionHandles) {
    if (!entries.length || !collectionHandles.length) {
      return false;
    }

    const normalizedHandles = new Set(parseHandleList(collectionHandles));
    return entries.some((entry) => {
      const entryHandle = extractHandle(entry);
      return entryHandle && normalizedHandles.has(entryHandle);
    });
  }


  class PricingEngine {
    constructor(root, settings) {
      this.root = root;
      this.settings = { ...DEFAULT_SETTINGS, ...settings };
      this.data = null;
      this.state = {
        productType: null,
        constructionType: null,
        color: null,
        lace: null,
        length: null,
        frontalSize: null,
        density: null,
        texture: null,
        capType: null,
        capSize: null,
        quantity: 1
      };
      this.groupDisabledState = {};
      this.groupNotRequiredState = {};
      this.lastResult = null;
      this.lastRenderedTotal = null;
      this.priceAnimationFrameId = null;
      this.scrollAnimationFrameId = null;
      this.sectionStickyObserver = null;
      this.shoppingList = [];
      this.editingItemId = null;
      this.activeAccordion = 'product_type';
      this.entryProfile = null;
      this.availableProductTypes = new Set();
      this.isQuotePage = typeof window !== 'undefined' && window.location ? isQuotePath(window.location.pathname) : false;
      this.productTypeLocked = this.isQuotePage;
      this.lockedFields = new Set(this.productTypeLocked ? ['product_type'] : []);
      this.allowedValues = {};
      this.quoteLengthValues = { assembled: null, integrated: null };
      this.quantityExceededLimit = false;
      this.isShoppingOpen = false;
      this.openShoppingItems = new Set();
      this.addedToShoppingList = false;
      this.elements = {
        total: null,
        totals: [],
        status: null,
        statuses: [],
        shippingStatus: null,
        shippingNote: null,
        summary: null,
        formula: null,
        qtyInput: null,
        addToList: null,
        whatsapp: null,
        listWrap: null,
        listEmpty: null,
        listSubtotal: null,
        listShipping: null,
        listTotal: null,
        clearList: null,
        listCount: null,
        shoppingToggle: null,
        shoppingBody: null,
        heroSticky: null,
        sectionSticky: null,
        paymentButtons: [],
        paymentLabels: {},
        paymentPrices: {},
        serviceFee: null,
        bleachFee: null,
        madeToOrderNote: null,
        qtyWarning: null,
        optionGroups: {},
        groupWrappers: {},
        accordionToggles: {},
        accordionPanels: {},
        groupValueLabels: {}
      };
    }

    async init() {
      this.cacheElements();

      if (!this.settings.dataUrl) {
        this.setStatus('Pricing data URL is missing.', true);
        return;
      }

      try {
        const response = await fetch(this.settings.dataUrl, { cache: 'no-store' });
        if (!response.ok) {
          throw new Error(`Failed to fetch pricing data: ${response.status}`);
        }
        this.data = stripRemovedProductData(await response.json());
      } catch (error) {
        this.setStatus('Unable to load pricing data. Please refresh the page.', true);
        return;
      }

      this.root.classList.toggle('is-quote-calculator', this.isQuotePage);

      this.availableProductTypes = new Set(
        (this.data.meta && this.data.meta.product_types ? this.data.meta.product_types : []).map((item) => item.id)
      );
      this.entryProfile = this.resolveEntryProfile();

      this.renderStaticOptionSets();
      this.applyInitialState();
      this.initializeAccordions();
      this.renderShoppingList();
      this.bindEvents();
      this.refresh();
      this.syncShoppingSection();
      this.paintQuantityWarning();
      this.setupSectionStickyVisibility();
    }

    cacheElements() {
      this.elements.totals = Array.from(this.root.querySelectorAll('[data-calc-total]'));
      this.elements.total = this.elements.totals[0] || null;
      this.elements.statuses = Array.from(this.root.querySelectorAll('[data-calc-status]'));
      this.elements.status = this.elements.statuses[0] || null;
      this.elements.shippingStatus = this.root.querySelector('[data-calc-shipping-status]');
      this.elements.shippingNote = this.root.querySelector('[data-calc-shipping-note]');
      this.elements.summary = this.root.querySelector('[data-calc-summary]');
      this.elements.formula = this.root.querySelector('[data-calc-formula]');
      this.elements.qtyInput = this.root.querySelector('[data-calc-quantity]');
      this.elements.addToList = this.root.querySelector('[data-calc-add-list]');
      this.elements.whatsapp = this.root.querySelector('[data-calc-whatsapp]');
      this.elements.listWrap = this.root.querySelector('[data-calc-shopping-list]');
      this.elements.listEmpty = this.root.querySelector('[data-calc-list-empty]');
      this.elements.listSubtotal = this.root.querySelector('[data-calc-list-subtotal]');
      this.elements.listShipping = this.root.querySelector('[data-calc-list-shipping]');
      this.elements.listTotal = this.root.querySelector('[data-calc-list-total]');
      this.elements.clearList = this.root.querySelector('[data-calc-clear-list]');
      this.elements.listCount = this.root.querySelector('[data-calc-list-count]');
      this.elements.shoppingToggle = this.root.querySelector('[data-calc-shopping-toggle]');
      this.elements.shoppingBody = this.root.querySelector('[data-calc-shopping-body]');
      this.elements.heroSticky = this.root.querySelector('.es-calc__sticky--hero');
      this.elements.sectionSticky = this.root.querySelector('.es-calc__sticky--section');
      this.elements.paymentButtons = Array.from(this.root.querySelectorAll('[data-calc-payment-option]'));
      this.elements.paymentLabels = {
        paypal: Array.from(this.root.querySelectorAll('[data-calc-payment-label="paypal"]')),
        bank: Array.from(this.root.querySelectorAll('[data-calc-payment-label="bank"]'))
      };
      this.elements.paymentPrices = {
        paypal: Array.from(this.root.querySelectorAll('[data-calc-payment-price="paypal"]')),
        bank: Array.from(this.root.querySelectorAll('[data-calc-payment-price="bank"]'))
      };
      this.elements.serviceFee = this.root.querySelector('[data-calc-service-fee]');
      this.elements.bleachFee = this.root.querySelector('[data-calc-bleach-fee]');
      this.elements.madeToOrderNote = this.root.querySelector('[data-calc-made-to-order-note]');
      this.elements.qtyWarning = this.root.querySelector('[data-calc-qty-warning]');

      if (this.elements.shoppingBody && !this.elements.shoppingBody.id) {
        const sectionId = this.root.dataset.sectionId || 'calc';
        this.elements.shoppingBody.id = `calc-shopping-body-${String(sectionId).replace(/[^a-zA-Z0-9_-]/g, '')}`;
      }
      if (this.elements.shoppingToggle && this.elements.shoppingBody && this.elements.shoppingBody.id) {
        this.elements.shoppingToggle.setAttribute('aria-controls', this.elements.shoppingBody.id);
      }

      Object.keys(OPTION_GROUP_MAP).forEach((field) => {
        const key = OPTION_GROUP_MAP[field];
        this.elements.optionGroups[key] = this.root.querySelector(`[data-calc-options="${key}"]`);
        this.elements.groupWrappers[key] = this.root.querySelector(`[data-calc-group="${key}"]`);
        this.elements.accordionToggles[key] = this.root.querySelector(`[data-calc-accordion-toggle="${key}"]`);
        this.elements.accordionPanels[key] = this.root.querySelector(`[data-calc-accordion-panel="${key}"]`);
        this.elements.groupValueLabels[key] = this.root.querySelector(`[data-calc-group-value="${key}"]`);
      });
    }

    bindEvents() {
      this.root.addEventListener('click', (event) => {
        const cancelEdit = event.target.closest('[data-calc-cancel-edit]');
        if (cancelEdit && this.root.contains(cancelEdit)) {
          this.editShoppingItem(this.editingItemId);
          return;
        }
        const newItemButton = event.target.closest('[data-calc-new-item]');
        if (newItemButton && this.root.contains(newItemButton)) {
          this.startNewItem();
          this.root.dispatchEvent(new CustomEvent('calc:edit-item'));
          return;
        }
        const editButton = event.target.closest('[data-calc-edit-list-id]');
        if (editButton && this.root.contains(editButton)) {
          this.editShoppingItem(editButton.dataset.calcEditListId);
          return;
        }
        const saveDraft = event.target.closest('[data-calc-save-draft]');
        if (saveDraft && this.root.contains(saveDraft)) {
          this.handleAddToList();
          return;
        }
        const shoppingToggle = event.target.closest('[data-calc-shopping-toggle]');
        if (shoppingToggle && this.root.contains(shoppingToggle)) {
          if (!this.shoppingList.length) {
            return;
          }
          this.isShoppingOpen = !this.isShoppingOpen;
          this.syncShoppingSection();
          return;
        }

        const accordionToggle = event.target.closest('[data-calc-accordion-toggle]');
        if (accordionToggle && this.root.contains(accordionToggle)) {
          const key = accordionToggle.dataset.calcAccordionToggle;
          if (key) {
            if (this.groupDisabledState[key] || this.isFieldLocked(key)) {
              return;
            }
            this.activeAccordion = this.activeAccordion === key ? null : key;
            this.syncAccordions();
          }
          return;
        }

        const removeButton = event.target.closest('[data-calc-remove-list-id]');
        if (removeButton && this.root.contains(removeButton)) {
          this.removeShoppingItem(removeButton.dataset.calcRemoveListId);
          return;
        }

        const itemToggle = event.target.closest('[data-calc-item-toggle-id]');
        if (itemToggle && this.root.contains(itemToggle)) {
          this.toggleShoppingItem(itemToggle.dataset.calcItemToggleId);
          return;
        }

        const tooltipToggle = event.target.closest('.es-calc__tooltip-toggle');
        if (tooltipToggle && this.root.contains(tooltipToggle)) {
          event.preventDefault();
          event.stopPropagation();
          this.toggleTooltip(tooltipToggle.closest('.es-calc__tooltip'));
          return;
        }

        const optionButton = event.target.closest('[data-calc-field][data-calc-value]');
        if (!optionButton || !this.root.contains(optionButton)) {
          return;
        }
        if (optionButton.disabled || optionButton.classList.contains('is-disabled')) {
          return;
        }

        const field = optionButton.dataset.calcField;
        const value = optionButton.dataset.calcValue;
        this.onOptionSelect(field, value);
      });

      if (this.elements.qtyInput) {
        this.elements.qtyInput.addEventListener('focus', () => {
          this.elements.qtyInput.dataset.focusValue = this.elements.qtyInput.value || '';
          this.elements.qtyInput.dataset.firstInput = '1';
          if (typeof this.elements.qtyInput.select === 'function') {
            this.elements.qtyInput.select();
          }
        });

        this.elements.qtyInput.addEventListener('input', () => {
          const input = this.elements.qtyInput;
          const previousQuantity = this.state.quantity;
          let rawValue = String(input.value || '').trim();

          // Mobile keyboards often append to the default value (e.g. 1 -> 13).
          // On the first keystroke after focus, treat that as replacement.
          if (
            input.dataset.firstInput === '1' &&
            input.dataset.focusValue &&
            rawValue.startsWith(input.dataset.focusValue) &&
            rawValue.length > input.dataset.focusValue.length
          ) {
            rawValue = rawValue.slice(input.dataset.focusValue.length);
            input.value = rawValue;
          }
          input.dataset.firstInput = '0';

          if (!rawValue) {
            this.quantityExceededLimit = false;
            this.paintQuantityWarning();
            return;
          }

          const maxQty = this.getMaxQuantity();
          const typedQty = toInt(rawValue, 1);
          this.quantityExceededLimit = typedQty > maxQty;
          this.state.quantity = this.getNormalizedQuantity(typedQty);
          if (this.state.quantity !== previousQuantity) {
            this.addedToShoppingList = false;
          }
          this.paintQuantityWarning();
          this.refresh();
        });

        this.elements.qtyInput.addEventListener('blur', () => {
          const input = this.elements.qtyInput;
          const previousQuantity = this.state.quantity;
          const typedQty = toInt(input.value, 1);
          this.quantityExceededLimit = typedQty > this.getMaxQuantity();
          this.state.quantity = this.getNormalizedQuantity(typedQty);
          if (this.state.quantity !== previousQuantity) {
            this.addedToShoppingList = false;
          }
          input.value = String(this.state.quantity);
          delete input.dataset.focusValue;
          delete input.dataset.firstInput;
          this.paintQuantityWarning();
          this.refresh();
        });
      }

      if (this.elements.addToList) {
        this.elements.addToList.addEventListener('click', async (event) => {
          event.preventDefault();
          this.handleAddToList();
        });
      }

      if (this.elements.whatsapp) {
        this.elements.whatsapp.addEventListener('click', (event) => {
          const url = this.buildWhatsAppUrl();
          if (!url) {
            event.preventDefault();
            this.setStatus('Select all required options and add a WhatsApp phone in section settings.', true);
            return;
          }
          this.elements.whatsapp.setAttribute('href', url);
        });
      }

      if (this.elements.clearList) {
        this.elements.clearList.addEventListener('click', (event) => {
          event.preventDefault();
          this.clearShoppingList();
        });
      }

      document.addEventListener('click', (event) => {
        if (!event.target.closest('.es-calc__tooltip')) {
          this.closeAllTooltips();
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          this.closeAllTooltips();
        }
      });

      this.root.addEventListener('mouseover', (event) => {
        const tooltip = event.target.closest('.es-calc__tooltip');
        if (tooltip) {
          this.positionTooltip(tooltip);
        }
      });

      this.root.addEventListener('focusin', (event) => {
        const tooltip = event.target.closest('.es-calc__tooltip');
        if (tooltip) {
          this.positionTooltip(tooltip);
        }
      });

      window.addEventListener('resize', () => {
        this.syncAccordions();
        this.syncShoppingItemPanels();
        this.repositionOpenTooltips();
        this.updateSectionStickyVisibility();
      });

      window.addEventListener('scroll', () => {
        this.updateSectionStickyVisibility();
      }, { passive: true });
    }

    setupSectionStickyVisibility() {
      if (typeof window === 'undefined') {
        return;
      }

      const heroSticky = this.elements.heroSticky;
      const sectionSticky = this.elements.sectionSticky;
      if (!heroSticky || !sectionSticky) {
        return;
      }

      if ('IntersectionObserver' in window) {
        this.sectionStickyObserver = new IntersectionObserver((entries) => {
          const entry = entries[0];
          this.setSectionStickyVisible(!(entry && entry.isIntersecting));
        }, {
          threshold: 0.01
        });
        this.sectionStickyObserver.observe(heroSticky);
      }

      this.updateSectionStickyVisibility();
    }

    updateSectionStickyVisibility() {
      const heroSticky = this.elements.heroSticky;
      const sectionSticky = this.elements.sectionSticky;
      if (!heroSticky || !sectionSticky || typeof window === 'undefined') {
        return;
      }

      if (this.sectionStickyObserver) {
        return;
      }

      const rect = heroSticky.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      const isVisible = rect.bottom > 0 && rect.top < viewportHeight;
      this.setSectionStickyVisible(!isVisible);
    }

    setSectionStickyVisible(isVisible) {
      if (!this.elements.sectionSticky) {
        return;
      }
      this.elements.sectionSticky.classList.toggle('is-visible', !!isVisible);
    }

    renderStaticOptionSets() {
      const meta = this.data.meta || {};

      this.renderOptions('product_type', (meta.product_types || []).filter((item) => PRODUCT_TYPE_ORDER.includes(item.id)).map((item) => ({
        id: item.id,
        label: item.label
      })));

      this.renderOptions('construction_type', (meta.construction_types || []).map((item) => ({
        id: item.id,
        label: item.label,
        tooltip: item.description || ''
      })));

      this.renderOptions('color', (this.data.color_options || []).map((item) => ({
        id: item.id,
        label: item.label,
        helperText: item.helper_text || '',
        metaText: (toNumber(item.fee_usd, 0) > 0 || item.id === 'natural_color' || item.id === '613')
          ? `+$${formatPercent(item.fee_usd)}`
          : ''
      })));

      this.renderOptions('lace', (meta.lace_types || []).map((item) => ({
        id: item.id,
        label: item.label
      })));

      this.renderOptions('frontal_size', (meta.frontals_sizes || []).map((item) => ({
        id: item.id,
        label: item.label
      })));

      this.renderDynamicOptionSets();

      this.renderOptions('texture', (this.data.texture_options || []).map((item) => ({
        id: item.id,
        label: item.label,
        metaText: toNumber(item.fee_usd, 0) > 0 ? `+$${toNumber(item.fee_usd, 0)}` : 'Free',
        tooltip: item.description || ''
      })));

      this.renderOptions('cap_type', (meta.cap_types || []).map((item) => ({
        id: item.id,
        label: item.label,
        metaText: '+$0'
      })));

      this.renderOptions('cap_size', (meta.cap_sizes || []).map((item) => ({
        id: item.id,
        label: item.label,
        metaText: '+$0',
        tooltip: item.tooltip || ''
      })));
    }

    renderDynamicOptionSets() {
      const meta = this.data && this.data.meta ? this.data.meta : {};
      this.renderOptions('length', this.getLengthOptions());
      this.renderOptions('density', (meta.densities || []).map((density) => ({
        id: String(density),
        label: this.getDensityLabel(String(density))
      })));
    }

    getLengthOptions() {
      const meta = this.data && this.data.meta ? this.data.meta : {};
      const layeredTooltip = meta.layered_length_tooltip || '';
      if (this.isIntegratedSelection()) {
        return this.getIntegratedSelectionLengths().map((length) => ({
          id: String(length),
          label: this.getDisplayLengthLabel(length),
          tooltip: layeredTooltip
        }));
      }

      return (meta.lengths || []).map((length) => ({
        id: String(length),
        label: this.getDisplayLengthLabel(length)
      }));
    }

    renderOptions(groupKey, options) {
      const container = this.elements.optionGroups[groupKey];
      if (!container) {
        return;
      }

      const html = options
        .map((option) => {
          const safeLabel = escapeHtml(this.getRenderedOptionLabel(groupKey, option));
          const safeValue = escapeHtml(String(option.id));
          const safeMetaText = escapeHtml(option.metaText || '');
          const tooltipText = String(option.tooltip || '').trim();
          const isColorGroup = groupKey === 'color';
          const tooltipMarkup = !isColorGroup && tooltipText
            ? `<div class="es-calc__tooltip">
                <button type="button" class="es-calc__tooltip-toggle" aria-label="${safeLabel} info">?</button>
                <div class="es-calc__tooltip-panel">${escapeHtml(tooltipText)}</div>
              </div>`
            : '';
          const colorNoteMarkup = isColorGroup ? this.getColorNoteMarkup(option) : '';
          const buttonContent = safeMetaText
            ? `<span class="es-calc__option-label">${safeLabel}</span><span class="es-calc__option-meta">${safeMetaText}</span>`
            : safeLabel;

          return `<div class="es-calc__option-cell">
              <div class="es-calc__option-row">
                <button type="button" class="es-calc__option" data-calc-field="${groupKey}" data-calc-value="${safeValue}">${buttonContent}</button>
                ${tooltipMarkup}
              </div>
              ${colorNoteMarkup}
              ${groupKey === 'construction_type' && option.id === 'integrated' && this.root.querySelector('[data-calc-reference="construction"]')
                ? '<button type="button" class="es-calc__reference-link" data-calc-reference-open="construction">Click here to see reference image</button>' : ''}
            </div>`;
        })
        .join('');
      // Keep focused controls and their DOM nodes when the option set is unchanged.
      if (container._calcOptionsMarkup !== html) {
        container.innerHTML = html;
        container._calcOptionsMarkup = html;
      }
    }

    getRenderedOptionLabel(groupKey, option) {
      if (groupKey === 'color' && option) {
        return this.getDisplayColorLabel(option.id);
      }
      return option && option.label ? option.label : '';
    }

    getColorNoteMarkup() {
      return '';
    }

    toggleTooltip(tooltip) {
      if (!tooltip) {
        return;
      }
      const isOpen = tooltip.classList.contains('is-open');
      this.closeAllTooltips();
      if (!isOpen) {
        tooltip.classList.add('is-open');
        this.positionTooltip(tooltip);
      }
    }

    closeAllTooltips() {
      this.root.querySelectorAll('.es-calc__tooltip.is-open').forEach((tooltip) => {
        tooltip.classList.remove('is-open');
      });
    }

    positionTooltip(tooltip) {
      const panel = tooltip ? tooltip.querySelector('.es-calc__tooltip-panel') : null;
      if (!panel || typeof window === 'undefined') {
        return;
      }

      const padding = 16;
      const viewportWidth = document.documentElement.clientWidth || window.innerWidth || 0;
      const maxWidth = Math.max(0, viewportWidth - padding * 2);

      panel.style.maxWidth = `${maxWidth}px`;
      panel.style.width = '';
      panel.style.left = '0';
      panel.style.right = 'auto';

      const measuredWidth = panel.getBoundingClientRect().width || panel.offsetWidth || 220;
      const panelWidth = Math.min(measuredWidth, maxWidth || measuredWidth);
      panel.style.width = `${panelWidth}px`;

      const tooltipRect = tooltip.getBoundingClientRect();
      const spaceRight = viewportWidth - tooltipRect.right - padding;
      const spaceLeft = tooltipRect.left - padding;
      const optionsGroup = tooltip.closest('[data-calc-options]');
      const groupKey = optionsGroup ? optionsGroup.getAttribute('data-calc-options') : '';
      const groupRect = optionsGroup ? optionsGroup.getBoundingClientRect() : null;
      const isDesktop = getViewportWidth() > WHATSAPP_MOBILE_BREAKPOINT;
      const isRightSideOption = groupRect
        ? (tooltipRect.left + (tooltipRect.width / 2)) >= (groupRect.left + (groupRect.width / 2))
        : false;
      const shouldOpenInward = isDesktop && (
        groupKey === 'cap_size' ||
        (groupKey === 'color' && isRightSideOption)
      );
      let left = 0;

      if (shouldOpenInward) {
        left = Math.max(tooltipRect.width - panelWidth, padding - tooltipRect.left);
      } else if (panelWidth <= spaceRight) {
        left = 0;
      } else if (panelWidth <= spaceLeft) {
        left = tooltipRect.right - panelWidth - tooltipRect.left;
      } else {
        left = Math.round((viewportWidth - panelWidth) / 2 - tooltipRect.left);
      }

      if (isDesktop && groupRect && groupRect.width > panelWidth + (padding * 2)) {
        const minLeft = groupRect.left + padding - tooltipRect.left;
        const maxLeft = groupRect.right - padding - panelWidth - tooltipRect.left;
        left = clamp(left, minLeft, maxLeft);
      }

      panel.style.left = `${left}px`;
    }

    repositionOpenTooltips() {
      this.root.querySelectorAll('.es-calc__tooltip.is-open').forEach((tooltip) => {
        this.positionTooltip(tooltip);
      });
    }

    applyInitialState() {
      this.state.productType = this.getDefaultProductType();
      this.state.constructionType = null;
      this.state.color = null;
      this.state.lace = null;
      this.state.length = null;
      this.state.frontalSize = null;
      this.state.density = null;
      this.state.texture = null;
      this.state.capType = null;
      this.state.capSize = null;
      this.state.quantity = this.getNormalizedQuantity(1);
      this.quantityExceededLimit = false;
      this.addedToShoppingList = false;
      this.applyQuoteUrlParameters();
      this.applyActiveQuoteLengthConstraint();

      if (this.elements.qtyInput) {
        if (document.activeElement !== this.elements.qtyInput) {
          this.elements.qtyInput.value = String(this.state.quantity);
        }
      }
    }

    getDefaultProductType() {
      if (this.productTypeLocked && this.availableProductTypes.has(QUOTE_FIXED_PRODUCT_TYPE)) {
        return QUOTE_FIXED_PRODUCT_TYPE;
      }
      return null;
    }

    applyQuoteUrlParameters() {
      this.allowedValues = {};
      this.quoteLengthValues = { assembled: null, integrated: null };
      const params = new URLSearchParams(window.location.search);
      params.forEach((raw, name) => {
        const key = normalizeQuoteParamKey(name);
        const field = this.resolveQuoteFieldFromParam(name);
        if (!field || !raw.trim()) return;
        const values = raw.split(',').map(value => this.resolveQuoteParamValue(field, name, value.trim())).filter(Boolean);
        if (field === 'length') {
          const targets = key === 'integratedlength' ? ['integrated'] : key === 'wiglength' ? ['assembled'] : ['assembled', 'integrated'];
          targets.forEach(target => {
            const subset = values.filter(value => String(value).includes('+') === (target === 'integrated'));
            // A legacy length list only constrains the construction types it contains.
            if (key === 'length' && !subset.length && values.length) return;
            this.quoteLengthValues[target] = new Set([...(this.quoteLengthValues[target] || []), ...subset]);
          });
          // Older links used wiglength for layered integrated lengths.
          if (key === 'wiglength' && values.some(value => value.includes('+'))) {
            this.quoteLengthValues.integrated = new Set(values.filter(value => value.includes('+')));
            if (!values.some(value => !value.includes('+'))) this.quoteLengthValues.assembled = null;
          }
        } else {
          this.allowedValues[field] = new Set([...(this.allowedValues[field] || []), ...values]);
        }
      });
      Object.entries(this.allowedValues).forEach(([field, allowed]) => {
        if (allowed.size === 1 && field !== 'product_type') this.setStateByField(field, [...allowed][0]);
      });
      this.applyActiveQuoteLengthConstraint();
    }

    getActiveQuoteLengthConstraint() {
      return this.quoteLengthValues[this.state.constructionType] || null;
    }

    getAllowedValues(field) {
      return field === 'length' ? this.getActiveQuoteLengthConstraint() : this.allowedValues[field];
    }

    applyActiveQuoteLengthConstraint() {
      const allowed = this.getActiveQuoteLengthConstraint();
      if (allowed && allowed.size === 1) this.state.length = [...allowed][0];
      else if (allowed && !allowed.has(this.state.length)) this.state.length = null;
    }

    resolveQuoteFieldFromParam(paramName) {
      const normalizedKey = normalizeQuoteParamKey(paramName);
      if (!normalizedKey) {
        return null;
      }

      if (QUOTE_PARAM_FIELDS[normalizedKey]) {
        return QUOTE_PARAM_FIELDS[normalizedKey];
      }

      return FIELD_ORDER.find((field) => normalizeQuoteParamKey(field) === normalizedKey) || null;
    }

    resolveQuoteParamValue(fieldName, paramName, paramValue) {
      const normalizedKey = normalizeQuoteParamKey(paramName);
      const rawValue = normalizeQuoteParamValue(paramValue);
      const mappedValue = QUOTE_PARAM_MAP[normalizedKey] && QUOTE_PARAM_MAP[normalizedKey][rawValue];

      if (mappedValue && this.isKnownOptionValue(fieldName, mappedValue)) {
        return mappedValue;
      }

      const comparableValue = normalizeQuoteComparableValue(paramValue);
      const option = this.getOptionsForField(fieldName).find((item) => {
        const candidates = [item.id, item.label, item.code, item.whatsapp_label].filter(Boolean);
        return candidates.some((candidate) => (
          normalizeQuoteParamValue(candidate) === rawValue ||
          normalizeQuoteComparableValue(candidate) === comparableValue
        ));
      });

      return option ? String(option.id) : null;
    }

    isFieldLocked(fieldName) {
      return fieldName === 'product_type' && this.productTypeLocked;
    }

    getOptionsForField(fieldName) {
      const meta = this.data && this.data.meta ? this.data.meta : {};

      switch (fieldName) {
        case 'product_type':
          return meta.product_types || [];
        case 'construction_type':
          return meta.construction_types || [];
        case 'color':
          return this.data.color_options || [];
        case 'lace':
          return meta.lace_types || [];
        case 'length':
          return [...new Set([
            ...(meta.lengths || []).map(String),
            ...Object.values((((this.data.products || {}).integrated_one_piece || {}).colors || {}))
              .flatMap((colorNode) => Object.values(colorNode || {}).flatMap((sizeNode) => Object.keys(sizeNode || {})))
          ])].map((length) => ({
            id: String(length),
            label: this.getDisplayLengthLabel(length)
          }));
        case 'frontal_size':
          return meta.frontals_sizes || [];
        case 'density':
          return (meta.densities || []).map((density) => ({
            id: String(density),
            label: String(density)
          }));
        case 'texture':
          return this.data.texture_options || [];
        case 'cap_type':
          return meta.cap_types || [];
        case 'cap_size':
          return meta.cap_sizes || [];
        default:
          return [];
      }
    }

    isKnownOptionValue(fieldName, value) {
      const normalizedValue = String(value || '');
      return this.getOptionsForField(fieldName).some((item) => String(item.id) === normalizedValue);
    }

    onOptionSelect(field, value) {
      if (this.getStateByField(field) === value) {
        return;
      }

      this.closeAllTooltips();
      this.addedToShoppingList = false;
      if (!FIELD_ORDER.includes(field)) {
        return;
      }
      const allowed = this.getAllowedValues(field);
      if (this.isFieldLocked(field) || (allowed && !allowed.has(value))) return;
      if (this.productTypeLocked && field === 'product_type' && value !== QUOTE_FIXED_PRODUCT_TYPE) {
        return;
      }
      this.setStateByField(field, value);
      if (field === 'construction_type') {
        this.applyActiveQuoteLengthConstraint();
      }
      if (!this.isQuotePage) this.clearSelectionsAfterField(field);
      this.refresh();
      if (!this.openNextAccordion(field)) {
        this.activeAccordion = null;
        this.syncAccordions();
      }
    }

    refresh() {
      if (!this.data) {
        return;
      }

      // Resolve dependent choices in order; URL allowlists never re-enable an
      // option rejected by the price tables or by an upstream choice.
      for (let pass = 0; pass < FIELD_ORDER.length; pass += 1) {
        const before = JSON.stringify(this.state);
        this.applyConstructionDefaults();
        this.renderDynamicOptionSets();
        this.applyFieldVisibility(this.updateUiState(this.state.productType));
        this.updateDynamicAvailability();
        this.applyLockedFieldState();
        this.ensureSelectedOptionsAreValid();
        FIELD_ORDER.forEach(field => {
          const allowed = this.getAllowedValues(field);
          if (!allowed || allowed.size !== 1 || this.getStateByField(field) || this.groupDisabledState[field]) return;
          const value = [...allowed][0];
          const button = this.elements.optionGroups[field]?.querySelector(`[data-calc-value="${CSS.escape(value)}"]`);
          if (button && !button.disabled) this.setStateByField(field, value);
        });
        if (JSON.stringify(this.state) === before) break;
      }
      this.paintOptionStates();
      this.syncAccordions();
      this.paintFeesAndConstructionNote();
      this.paintQuantityWarning();

      const result = this.calculate();
      this.lastResult = result;
      this.paintResult(result);
      this.updateActionButtons(result);
      this.root.dispatchEvent(new CustomEvent('calc:updated'));
    }

    updateUiState(productType) {
      if (!productType) {
        return {
          disabled: {
            product_type: false,
            construction_type: true,
            color: true,
            lace: true,
            length: true,
            frontal_size: true,
            density: true,
            texture: true,
            cap_type: true,
            cap_size: true
          },
          notRequired: {
            product_type: false,
            construction_type: false,
            color: false,
            lace: false,
            length: false,
            frontal_size: false,
            density: false,
            texture: false,
            cap_type: false,
            cap_size: false
          }
        };
      }

      const requiredFields = this.getRequiredFields(productType);
      const disabled = {};
      const notRequired = {};

      FIELD_ORDER.forEach((field) => {
        if (field === 'product_type') {
          disabled[field] = false;
          notRequired[field] = false;
          return;
        }

        const isRequired = requiredFields.includes(field);
        notRequired[field] = !isRequired;

        if (!isRequired) {
          disabled[field] = true;
          return;
        }

        if (this.isQuotePage) {
          disabled[field] = false;
          return;
        }

        const fieldIndex = requiredFields.indexOf(field);
        const previousFields = requiredFields.slice(0, fieldIndex);
        disabled[field] = !previousFields.every((previousField) => Boolean(this.getStateByField(previousField)));
      });

      if (productType === 'custom_bundle_wig' && this.isIntegratedSelection()) {
        disabled.lace = true;
        notRequired.lace = false;
      }

      return { disabled, notRequired };
    }

    getRequiredFields(productType = this.state.productType) {
      return PRODUCT_FIELD_FLOWS[productType] || ['product_type'];
    }

    applyConstructionDefaults() {
      if (this.isIntegratedSelection()) {
        this.state.lace = 'hd_lace';
      }
    }

    applyFieldVisibility(uiState) {
      this.groupDisabledState = { ...uiState.disabled };
      this.groupNotRequiredState = { ...uiState.notRequired };

      Object.keys(this.groupDisabledState).forEach((groupKey) => {
        const wrapper = this.elements.groupWrappers[groupKey];
        const disabled = this.groupDisabledState[groupKey];
        if (wrapper) {
          wrapper.classList.toggle('is-disabled', disabled);
        }
      });

      Object.keys(this.groupNotRequiredState).forEach((groupKey) => {
        if (this.groupNotRequiredState[groupKey]) {
          this.setStateByField(groupKey, null);
        }
      });
    }

    resetGroupButtonStates(groupKey) {
      const container = this.elements.optionGroups[groupKey];
      if (!container) {
        return;
      }
      container.querySelectorAll('[data-calc-field]').forEach((button) => {
        button.disabled = false;
        button.classList.remove('is-disabled');
        button.removeAttribute('title');
      });
    }

    disableOption(groupKey, value, titleText) {
      const container = this.elements.optionGroups[groupKey];
      if (!container) {
        return;
      }
      const button = container.querySelector(`[data-calc-value="${CSS.escape(value)}"]`);
      if (!button) {
        return;
      }
      button.disabled = true;
      button.classList.add('is-disabled');
      if (titleText) {
        button.setAttribute('title', titleText);
      }
    }

    applyLockedFieldState() {
      FIELD_ORDER.forEach(field => {
        const allowed = this.getAllowedValues(field);
        const container = this.elements.optionGroups[field];
        if (!container) return;
        container.querySelectorAll('[data-calc-field]').forEach(button => {
          if ((allowed && !allowed.has(button.dataset.calcValue)) ||
              (this.isFieldLocked(field) && button.dataset.calcValue !== QUOTE_FIXED_PRODUCT_TYPE)) {
            button.disabled = true;
            button.classList.add('is-disabled');
            button.title = 'Not available for this style';
          }
        });
      });
    }

    getColorOption() {
      return getOptionById(this.data.color_options || [], this.state.color);
    }

    getTextureOption() {
      return getOptionById(this.data.texture_options || [], this.state.texture);
    }

    getColorFee() {
      const option = this.getColorOption();
      return option ? toNumber(option.fee_usd, 0) : 0;
    }

    getTextureFee() {
      const option = this.getTextureOption();
      return option ? toNumber(option.fee_usd, 0) : 0;
    }

    isDyedColor() {
      return this.getColorFee() > 0;
    }

    getBaseColorKey() {
      const color = this.getColorOption();
      return color ? color.base_color_key : null;
    }

    getCustomWigFrontalLookupLength(length) {
      const normalizedLength = String(length || '').trim();
      return normalizedLength.split('+')[0];
    }

    getDensityBundleQty(density) {
      return toInt((this.data.meta.density_to_bundle_qty || {})[String(density)], 0);
    }

    getDensityLabel(density, productType = this.state.productType) {
      const normalizedDensity = String(density || '').trim();
      if (!normalizedDensity) {
        return '';
      }

      return `${normalizedDensity}%`;
    }

    isIntegratedSelection() {
      return this.state.productType === 'custom_bundle_wig' && this.state.constructionType === 'integrated';
    }

    getIntegratedSizeNode(baseColorKey, frontalSize) {
      const product = ((this.data || {}).products || {}).integrated_one_piece || {};
      const colorNode = (product.colors || {})[baseColorKey || ''];
      return colorNode ? colorNode[frontalSize || ''] || null : null;
    }

    getIntegratedLengths(baseColorKey, frontalSize) {
      const sizeNode = this.getIntegratedSizeNode(baseColorKey, frontalSize);
      return sizeNode ? Object.keys(sizeNode) : [];
    }

    getIntegratedSelectionLengths() {
      const directLengths = this.getIntegratedLengths(this.getBaseColorKey(), this.state.frontalSize);
      if (directLengths.length) {
        return directLengths;
      }
      if (this.getBaseColorKey() === '613' && this.state.frontalSize && this.state.frontalSize !== '13x6') {
        return this.getIntegratedLengths('613', '13x6');
      }
      return [];
    }

    getIntegratedPrice(baseColorKey, frontalSize, length, density) {
      const sizeNode = this.getIntegratedSizeNode(baseColorKey, frontalSize);
      const lengthNode = sizeNode && sizeNode[String(length || '')];
      return lengthNode ? lengthNode[String(density || '')] : null;
    }

    getMtoComponentLaceKey() {
      const product = ((this.data || {}).products || {}).integrated_one_piece || {};
      return product.mto_component_lace_key || 'transparent_lace';
    }

    isIntegratedDirectCandidate() {
      return this.isIntegratedSelection()
        && this.state.lace === 'hd_lace'
        && this.getIntegratedLengths(this.getBaseColorKey(), this.state.frontalSize).length > 0;
    }

    getConstructionPath() {
      if (this.state.productType !== 'custom_bundle_wig') {
        return null;
      }
      if (!this.isIntegratedSelection()) {
        return 'assembled_native';
      }
      if (this.isIntegratedDirectCandidate()) {
        return 'integrated_flat';
      }
      if (this.getBaseColorKey() === '613' && this.state.frontalSize && this.state.frontalSize !== '13x6') {
        return 'integrated_mto_component';
      }
      return null;
    }

    getConstructionLabel(path = this.getConstructionPath()) {
      if (path === 'integrated_mto_component') {
        return 'Integrated One-Piece (made-to-order)';
      }
      if (path === 'integrated_flat') {
        return 'Integrated One-Piece Construction';
      }
      if (path === 'assembled_native') {
        return 'Assembled Construction';
      }
      return 'N/A';
    }

    getDisplayLengthLabel(length) {
      const normalized = String(length || '').trim();
      if (!normalized) {
        return '';
      }
      const layered = normalized.match(/^(\d+)\+(\d+)$/);
      if (layered) {
        return `${layered[1]}”–${layered[2]}” (Layered)`;
      }
      return `${normalized.replace(/"+$/, '')}"`;
    }

    hasAnyAssembledLengthForSize(baseColorKey, lace, frontalSize) {
      if (!baseColorKey || !lace || !frontalSize) {
        return false;
      }
      return (this.data.meta.lengths || []).some((length) => {
        const normalizedLength = String(length);
        const bundlePrice = this.getHairBundlePrice(baseColorKey, normalizedLength);
        const frontalPrice = this.getFrontalPrice(
          baseColorKey,
          lace,
          normalizedLength,
          frontalSize
        );
        return isFiniteNumber(bundlePrice) && isFiniteNumber(frontalPrice);
      });
    }

    hasAnyMtoLengthForSize(baseColorKey, frontalSize) {
      if (baseColorKey !== '613' || !frontalSize) {
        return false;
      }
      return this.getIntegratedLengths('613', '13x6').some((layeredLength) => {
        const componentLength = this.getCustomWigFrontalLookupLength(layeredLength);
        const bundlePrice = this.getHairBundlePrice(baseColorKey, componentLength);
        const frontalPrice = this.getFrontalPrice(baseColorKey, this.getMtoComponentLaceKey(), componentLength, frontalSize);
        return isFiniteNumber(bundlePrice) && isFiniteNumber(frontalPrice);
      });
    }

    hasAnyFrontalLengthForSize(baseColorKey, lace, frontalSize) {
      if (!baseColorKey || !lace || !frontalSize) {
        return false;
      }
      return (this.data.meta.lengths || []).some((length) => (
        isFiniteNumber(this.getFrontalPrice(baseColorKey, lace, String(length), frontalSize))
      ));
    }

    isDensityDisabledForProductType(productType, density) {
      const normalizedDensity = String(density || '').trim();
      if (productType === 'custom_bundle_wig') {
        return CUSTOM_WIG_DISABLED_DENSITIES.has(normalizedDensity) || !this.getDensityBundleQty(normalizedDensity);
      }
      if (productType === 'full_lace') {
        return FULL_LACE_DISABLED_DENSITIES.has(normalizedDensity);
      }
      return false;
    }

    getMaxQuantity() {
      return clamp(toInt(this.settings.maxQuantity, 99), 1, 9999);
    }

    getNormalizedQuantity(value) {
      const maxQty = this.getMaxQuantity();
      return clamp(toInt(value, 1), 1, maxQty);
    }

    paintQuantityWarning() {
      if (!this.elements.qtyWarning) {
        return;
      }

      if (this.quantityExceededLimit) {
        this.elements.qtyWarning.hidden = false;
        this.elements.qtyWarning.textContent = `Please contact us for bulk orders exceeding ${this.getMaxQuantity() + 1} pieces.`;
        return;
      }

      this.elements.qtyWarning.hidden = true;
      this.elements.qtyWarning.textContent = '';
    }

    getServiceFee() {
      const path = this.getConstructionPath();
      if (path === 'assembled_native' || path === 'integrated_mto_component') {
        return toNumber(this.settings.customWigFee, 8);
      }
      return 0;
    }

    getBleachFee() {
      if (this.getConstructionPath() === 'assembled_native' && this.isDyedColor()) {
        return toNumber(this.settings.bleachKnotFee, 5);
      }
      return 0;
    }

    paintFeesAndConstructionNote() {
      if (this.elements.serviceFee) {
        this.elements.serviceFee.textContent = formatUsd(this.getServiceFee());
      }
      if (this.elements.bleachFee) {
        this.elements.bleachFee.textContent = formatUsd(this.getBleachFee());
      }
      this.paintConstructionNote();
    }

    paintConstructionNote() {
      if (!this.elements.madeToOrderNote) {
        return;
      }
      const show = this.isIntegratedSelection()
        && this.getBaseColorKey() === '613';
      this.elements.madeToOrderNote.hidden = !show;
      this.elements.madeToOrderNote.textContent = show
        ? ((this.data.meta || {}).made_to_order_note || '')
        : '';
    }

    normalizeProductTypeId(value) {
      if (!value) {
        return null;
      }
      const normalized = String(value).trim().toLowerCase();
      return PRODUCT_TYPE_ORDER.includes(normalized) ? normalized : null;
    }

    readEntryPointFromQuery() {
      if (typeof window === 'undefined' || !window.location || !window.location.search) {
        return null;
      }

      const params = new URLSearchParams(window.location.search);
      for (const key of ENTRY_QUERY_KEYS) {
        const resolved = normalizeEntryPoint(params.get(key));
        if (resolved !== 'auto') {
          return resolved;
        }
      }

      return null;
    }

    detectEntryPointFromPath() {
      if (typeof window === 'undefined' || !window.location || !window.location.pathname) {
        return 'homepage';
      }

      const path = normalizePath(window.location.pathname);
      const styleTypeColorPaths = [
        ...parsePathList(this.settings.galleryStyleHandles),
        ...parsePathList(this.settings.galleryColorHandles),
        ...parsePathList(this.settings.galleryTypeHandles)
      ];

      if (path === '/' || matchesConfiguredPath(parsePathList(this.settings.homepageHandles), path)) {
        return 'homepage';
      }
      if (matchesConfiguredPath(parsePathList(this.settings.bestSellersHandles), path)) {
        return 'best_sellers';
      }
      if (matchesConfiguredPath(parsePathList(this.settings.hdFrontalsHandles), path)) {
        return 'frontals';
      }
      if (matchesConfiguredPath(parsePathList(this.settings.bundlesHandles), path)) {
        return 'bundles';
      }
      if (matchesConfiguredPath(styleTypeColorPaths, path)) {
        return 'style_type_color';
      }

      if (path.includes('best-seller') || path.includes('bestseller')) {
        return 'best_sellers';
      }
      if (path.includes('frontals')) {
        return 'frontals';
      }
      if (path.includes('bundles')) {
        return 'bundles';
      }
      if (path.includes('style') || path.includes('type') || path.includes('color')) {
        return 'style_type_color';
      }

      return 'homepage';
    }

    detectEntryPointFromCollections() {
      const collectionHandles = parseHandleList(this.settings.productCollectionHandles);
      if (!collectionHandles.length) {
        return null;
      }

      const styleTypeColorHandles = [
        ...parsePathList(this.settings.galleryStyleHandles),
        ...parsePathList(this.settings.galleryColorHandles),
        ...parsePathList(this.settings.galleryTypeHandles)
      ];

      if (matchesConfiguredHandle(parsePathList(this.settings.hdFrontalsHandles), collectionHandles)) {
        return 'frontals';
      }
      if (matchesConfiguredHandle(parsePathList(this.settings.bundlesHandles), collectionHandles)) {
        return 'bundles';
      }
      if (matchesConfiguredHandle(styleTypeColorHandles, collectionHandles)) {
        return 'style_type_color';
      }
      if (matchesConfiguredHandle(parsePathList(this.settings.bestSellersHandles), collectionHandles)) {
        return 'best_sellers';
      }

      if (collectionHandles.some((handle) => handle.includes('frontal'))) {
        return 'frontals';
      }
      if (collectionHandles.some((handle) => handle.includes('bundle'))) {
        return 'bundles';
      }
      if (collectionHandles.some((handle) => handle.includes('style') || handle.includes('type') || handle.includes('color'))) {
        return 'style_type_color';
      }
      if (collectionHandles.some((handle) => handle.includes('best-seller') || handle.includes('bestseller'))) {
        return 'best_sellers';
      }

      return null;
    }

    resolveEntryProfile() {
      const fromQuery = this.readEntryPointFromQuery();
      const fromSetting = normalizeEntryPoint(this.settings.entryPoint);
      const resolvedId = fromQuery || (fromSetting !== 'auto' ? fromSetting : (this.detectEntryPointFromCollections() || this.detectEntryPointFromPath()));
      const baseProfile = ENTRY_PROFILES[resolvedId] || ENTRY_PROFILES.homepage;

      const enabledProductTypes = (baseProfile.enabledProductTypes || []).filter((id) => this.availableProductTypes.has(id));
      return {
        ...baseProfile,
        enabledProductTypes
      };
    }

    getEnabledProductTypes() {
      const fromProfile = this.entryProfile && Array.isArray(this.entryProfile.enabledProductTypes)
        ? this.entryProfile.enabledProductTypes
        : [];
      if (fromProfile.length) {
        return fromProfile;
      }
      return PRODUCT_TYPE_ORDER.filter((id) => this.availableProductTypes.has(id));
    }

    applyProductTypeEntryVisibility() {
      const allowed = new Set(this.getEnabledProductTypes());
      if (this.productTypeLocked) {
        allowed.clear();
        allowed.add(QUOTE_FIXED_PRODUCT_TYPE);
      }
      (this.data.meta.product_types || []).forEach((item) => {
        if (!allowed.has(item.id)) {
          this.disableOption('product_type', item.id, 'Not available for this page');
        }
      });
    }

    updateDynamicAvailability() {
      FIELD_ORDER.forEach((groupKey) => {
        this.resetGroupButtonStates(groupKey);
      });

      Object.keys(this.groupDisabledState).forEach((groupKey) => {
        if (!this.groupDisabledState[groupKey]) {
          return;
        }
        const container = this.elements.optionGroups[groupKey];
        if (!container) {
          return;
        }
        container.querySelectorAll('[data-calc-field]').forEach((button) => {
          button.disabled = true;
          button.classList.add('is-disabled');
        });
      });

      this.applyProductTypeEntryVisibility();

      const productType = this.state.productType;
      const baseColorKey = this.getBaseColorKey();

      if (productType === 'hair_bundles_only') {
        const product = (this.data.products || {}).hair_bundles_only || {};
        const allowedColors = new Set(product.available_colors || []);
        (this.data.color_options || []).forEach((color) => {
          if (allowedColors.size && !allowedColors.has(color.id)) {
            this.disableOption('color', color.id, 'Hair Bundles Only is available in Natural and Dark Solid colors.');
          }
        });

        (this.data.meta.lengths || []).forEach((length) => {
          const price = this.getHairBundlePrice(baseColorKey, String(length));
          if (!isFiniteNumber(price)) {
            this.disableOption('length', String(length), 'Not available for this color');
          }
        });
      }

      if (productType === 'custom_bundle_wig') {
        const integrated = this.isIntegratedSelection();
        if (integrated) {
          this.disableOption('lace', 'transparent_lace', 'Integrated One-Piece Construction is available in HD Lace only.');
        }

        (this.data.meta.frontals_sizes || []).forEach((sizeOption) => {
          const size = sizeOption.id;
          const hasDirectTable = this.getIntegratedLengths(baseColorKey, size).length > 0;
          const canUseMadeToOrder = integrated && size !== '13x6' && this.hasAnyMtoLengthForSize(baseColorKey, size);
          const available = integrated
            ? (this.state.lace === 'hd_lace' && (hasDirectTable || canUseMadeToOrder))
            : this.hasAnyAssembledLengthForSize(baseColorKey, this.state.lace, size);
          if (!available) {
            this.disableOption('frontal_size', size, integrated
              ? 'Not available for Integrated One-Piece with this color/lace.'
              : 'Not available for this color/lace combination.');
          }
        });

        const directCandidate = this.isIntegratedDirectCandidate();
        if (integrated && !directCandidate) {
          this.getIntegratedSelectionLengths().forEach((layeredLength) => {
            const componentLength = this.getCustomWigFrontalLookupLength(layeredLength);
            const frontalPrice = this.getFrontalPrice(baseColorKey, this.getMtoComponentLaceKey(), componentLength, this.state.frontalSize);
            const bundlePrice = this.getHairBundlePrice(baseColorKey, componentLength);
            if (!isFiniteNumber(frontalPrice) || !isFiniteNumber(bundlePrice)) {
              this.disableOption('length', layeredLength, 'Not available for this made-to-order size.');
            }
          });
        } else if (!integrated) {
          (this.data.meta.lengths || []).forEach((length) => {
            const normalizedLength = String(length);
            const frontalPrice = this.getFrontalPrice(
              baseColorKey,
              this.state.lace,
              normalizedLength,
              this.state.frontalSize
            );
            const bundlePrice = this.getHairBundlePrice(baseColorKey, normalizedLength);
            if (!isFiniteNumber(frontalPrice) || !isFiniteNumber(bundlePrice)) {
              this.disableOption('length', normalizedLength, 'Not available for this color/lace/size combination.');
            }
          });
        }

        (this.data.meta.densities || []).forEach((density) => {
          const normalizedDensity = String(density);
          const unavailable = directCandidate
            ? !isFiniteNumber(this.getIntegratedPrice(baseColorKey, this.state.frontalSize, this.state.length, normalizedDensity))
            : this.isDensityDisabledForProductType(productType, normalizedDensity);
          if (unavailable) {
            this.disableOption('density', normalizedDensity, directCandidate
              ? 'Not available for this Integrated One-Piece size/length.'
              : 'Not available for Custom Lace Wig.');
          }
        });
      }

      if (productType === 'frontals_only') {
        (this.data.meta.frontals_sizes || []).forEach((sizeOption) => {
          if (!this.hasAnyFrontalLengthForSize(baseColorKey, this.state.lace, sizeOption.id)) {
            this.disableOption('frontal_size', sizeOption.id, 'Not available for this color/lace combination.');
          }
        });

        (this.data.meta.lengths || []).forEach((length) => {
          const normalizedLength = String(length);
          const frontalPrice = this.getFrontalPrice(baseColorKey, this.state.lace, normalizedLength, this.state.frontalSize);
          if (!isFiniteNumber(frontalPrice)) {
            this.disableOption('length', normalizedLength, 'Not available for this color/lace/size combination.');
          }
        });
      }

      if (productType === 'full_lace') {
        (this.data.meta.densities || []).forEach((density) => {
          if (this.isDensityDisabledForProductType(productType, String(density))) {
            this.disableOption('density', String(density), 'Not available for Full Lace Wig');
          }
        });
        (this.data.meta.lengths || []).forEach((length) => {
          const hasAnyDensity = this.hasAnyFullLaceDensity(baseColorKey, this.state.lace, String(length));
          if (!hasAnyDensity) {
            this.disableOption('length', String(length), 'Not available for this lace/color combination');
          }
        });

        (this.data.meta.densities || []).forEach((density) => {
          const fullLacePrice = this.getFullLacePrice(baseColorKey, this.state.lace, this.state.length, String(density));
          if (!isFiniteNumber(fullLacePrice)) {
            this.disableOption('density', String(density), 'Not available for this lace/size combination');
          }
        });
      }

      this.paintConstructionNote();
    }

    ensureSelectedOptionsAreValid() {
      FIELD_ORDER.forEach((fieldName) => {
        const groupKey = OPTION_GROUP_MAP[fieldName] || fieldName;
        const selectedValue = this.getStateByField(fieldName);

        if (this.isFieldLocked(fieldName)) {
          return;
        }

        if (this.groupDisabledState[groupKey]) {
          if (this.groupNotRequiredState[groupKey]) {
            this.setStateByField(fieldName, null);
          }
          return;
        }

        const container = this.elements.optionGroups[groupKey];
        if (!container) {
          return;
        }

        const selectedButton = selectedValue
          ? container.querySelector(`[data-calc-value="${CSS.escape(String(selectedValue))}"]`)
          : null;

        if (selectedButton && !selectedButton.disabled) {
          return;
        }

        this.setStateByField(fieldName, null);
      });
    }

    getStateByField(fieldName) {
      switch (fieldName) {
        case 'product_type':
          return this.state.productType;
        case 'construction_type':
          return this.state.constructionType;
        case 'color':
          return this.state.color;
        case 'lace':
          return this.state.lace;
        case 'length':
          return this.state.length;
        case 'frontal_size':
          return this.state.frontalSize;
        case 'density':
          return this.state.density;
        case 'texture':
          return this.state.texture;
        case 'cap_type':
          return this.state.capType;
        case 'cap_size':
          return this.state.capSize;
        default:
          return null;
      }
    }

    setStateByField(fieldName, value) {
      switch (fieldName) {
        case 'product_type':
          this.state.productType = value;
          break;
        case 'construction_type':
          this.state.constructionType = value;
          break;
        case 'color':
          this.state.color = value;
          break;
        case 'lace':
          this.state.lace = value;
          break;
        case 'length':
          this.state.length = value;
          break;
        case 'frontal_size':
          this.state.frontalSize = value;
          break;
        case 'density':
          this.state.density = value;
          break;
        case 'texture':
          this.state.texture = value;
          break;
        case 'cap_type':
          this.state.capType = value;
          break;
        case 'cap_size':
          this.state.capSize = value;
          break;
        default:
          break;
      }
    }

    clearSelectionsAfterField(fieldName) {
      const currentIndex = FIELD_ORDER.indexOf(fieldName);
      if (currentIndex < 0) {
        return;
      }

      FIELD_ORDER.slice(currentIndex + 1).forEach((nextField) => {
        this.setStateByField(nextField, null);
      });
    }

    paintOptionStates() {
      Object.keys(this.elements.optionGroups).forEach((groupKey) => {
        const container = this.elements.optionGroups[groupKey];
        if (!container) {
          return;
        }

        container.querySelectorAll('[data-calc-field][data-calc-value]').forEach((button) => {
          const field = button.dataset.calcField;
          const value = button.dataset.calcValue;
          const isSelected = this.getStateByField(field) === value;
          button.classList.toggle('is-active', isSelected);
          button.setAttribute('aria-pressed', String(isSelected));
        });

        const wrapper = this.elements.groupWrappers[groupKey];
        if (wrapper) {
          const selectedValue = this.getStateByField(groupKey);
          const hasSelection = Boolean(selectedValue) && !this.groupNotRequiredState[groupKey];
          const isForcedLocked = groupKey === 'lace'
            && this.isIntegratedSelection()
            && selectedValue === 'hd_lace';
          wrapper.classList.toggle('has-selection', hasSelection);
          wrapper.classList.toggle('is-forced-locked', isForcedLocked);
        }
      });

      if (this.elements.qtyInput) {
        if (document.activeElement !== this.elements.qtyInput) {
          this.elements.qtyInput.value = String(this.state.quantity);
        }
      }

      this.paintAccordionSummaries();
    }

    initializeAccordions() {
      this.activeAccordion = this.getInitialAccordion();
      this.syncAccordions();
    }

    getInitialAccordion() {
      if (!this.productTypeLocked) {
        return 'product_type';
      }

      return this.getFirstIncompleteRequiredField();
    }

    getFirstIncompleteRequiredField(startAfterField = 'product_type') {
      const productType = this.state.productType;
      const requiredFields = this.getRequiredFields(productType);
      const startIndex = FIELD_ORDER.indexOf(startAfterField);

      return FIELD_ORDER
        .filter((field) => requiredFields.includes(field) && field !== 'product_type')
        .filter((field) => startIndex < 0 || FIELD_ORDER.indexOf(field) > startIndex)
        .find((field) => (
          this.elements.groupWrappers[field] &&
          !this.groupDisabledState[field] &&
          !this.isFieldLocked(field) &&
          !this.getStateByField(field)
        )) || null;
    }

    openNextAccordion(currentField) {
      const index = FIELD_ORDER.indexOf(currentField);
      if (index < 0) {
        return false;
      }

      if (this.productTypeLocked) {
        const nextIncompleteField = this.getFirstIncompleteRequiredField(currentField);
        if (nextIncompleteField) {
          this.activeAccordion = nextIncompleteField;
          this.syncAccordions();
          return true;
        }
        return false;
      }

      const nextField = FIELD_ORDER
        .slice(index + 1)
        .find((field) => (
          this.elements.groupWrappers[field] &&
          !this.groupDisabledState[field] &&
          !this.isFieldLocked(field) &&
          !this.getStateByField(field)
        ));

      if (nextField) {
        this.activeAccordion = nextField;
        this.syncAccordions();
        return true;
      }

      return false;
    }

    syncAccordions() {
      const fields = FIELD_ORDER.filter((field) => this.elements.groupWrappers[field]);
      if (!fields.length) {
        return;
      }

      if (
        this.activeAccordion &&
        (
          this.groupDisabledState[this.activeAccordion] ||
          this.isFieldLocked(this.activeAccordion) ||
          !fields.includes(this.activeAccordion)
        )
      ) {
        this.activeAccordion = null;
      }

      fields.forEach((field) => {
        const wrapper = this.elements.groupWrappers[field];
        const toggle = this.elements.accordionToggles[field];
        const panel = this.elements.accordionPanels[field];
        const isDisabled = !!this.groupDisabledState[field] || this.isFieldLocked(field);
        const isOpen = !isDisabled && this.activeAccordion === field;

        if (wrapper) {
          wrapper.classList.toggle('is-open', isOpen);
        }

        if (toggle) {
          toggle.disabled = isDisabled;
          toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        }

        if (panel) {
          if (!isOpen && panel.contains(document.activeElement)) {
            const nextToggle = this.elements.accordionToggles[this.activeAccordion];
            (nextToggle || toggle)?.focus({ preventScroll: true });
          }
          this.setPanelOpen(panel, isOpen);
        }
      });
    }

    setPanelOpen(panel, isOpen) {
      const previous = panel.dataset.calcOpen;
      panel.setAttribute('aria-hidden', String(!isOpen));
      panel.inert = !isOpen;
      if (previous === String(isOpen)) return;

      const startHeight = panel.hidden ? 0 : panel.getBoundingClientRect().height;
      panel._calcAnimation?.cancel();
      panel.dataset.calcOpen = String(isOpen);
      panel.hidden = false;
      panel.style.maxHeight = 'none';
      const endHeight = isOpen ? panel.scrollHeight : 0;
      const finish = () => {
        panel.hidden = !isOpen;
        panel.style.overflow = '';
        panel._calcAnimation = null;
      };
      if (previous === undefined || !panel.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        finish();
        return;
      }
      panel.style.overflow = 'hidden';
      const animation = panel.animate(
        [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
        { duration: 200, easing: 'cubic-bezier(.2,.7,.3,1)' }
      );
      panel._calcAnimation = animation;
      animation.onfinish = finish;
    }

    paintAccordionSummaries() {
      FIELD_ORDER.forEach((field) => {
        const node = this.elements.groupValueLabels[field];
        if (!node) {
          return;
        }

        if (this.groupDisabledState[field]) {
          if (this.groupNotRequiredState[field]) {
            node.textContent = 'Not required';
            return;
          }
          if (field === 'lace' && this.isIntegratedSelection()) {
            node.textContent = this.getSummaryLabelForField(field);
            return;
          }
          node.textContent = 'Select';
          return;
        }

        if (this.groupNotRequiredState[field]) {
          node.textContent = 'Not required';
          return;
        }

        const label = this.getSummaryLabelForField(field);
        node.textContent = label
          ? label
          : 'Select';
      });
    }

    getSummaryLabelForField(field) {
      if (field === 'product_type') {
        return this.state.productType ? this.getProductTypeLabel(this.state.productType) : '';
      }
      if (field === 'construction_type') {
        return this.state.constructionType ? this.getConstructionLabel(
          this.state.constructionType === 'integrated' ? 'integrated_flat' : 'assembled_native'
        ) : '';
      }
      if (field === 'color') {
        return this.state.color ? this.getDisplayColorLabel(this.state.color) : '';
      }
      if (field === 'lace') {
        return this.state.lace ? this.getLaceLabel(this.state.lace) : '';
      }
      if (field === 'length') {
        return this.getDisplayLengthLabel(this.state.length);
      }
      if (field === 'frontal_size') {
        return this.state.frontalSize ? this.getFrontalSizeLabel(this.state.frontalSize) : '';
      }
      if (field === 'density') {
        return this.state.density ? this.getDensityLabel(this.state.density) : '';
      }
      if (field === 'texture') {
        return this.state.texture ? this.getTextureLabel(this.state.texture) : '';
      }
      if (field === 'cap_type') {
        return this.state.capType ? this.getCapTypeLabel(this.state.capType) : '';
      }
      if (field === 'cap_size') {
        return this.state.capSize ? this.getCapSizeLabel(this.state.capSize) : '';
      }
      return '';
    }

    getHairBundlePrice(baseColorKey, length) {
      const safeColor = baseColorKey || 'natural_color';
      const products = this.data.products || {};
      const table = products.hair_bundles_only || {};
      const colors = table.colors || {};
      return colors[safeColor] ? colors[safeColor][String(length)] : null;
    }

    getFrontalPrice(baseColorKey, lace, length, frontalSize) {
      const safeColor = baseColorKey || 'natural_color';
      const products = this.data.products || {};
      const table = products.frontals_only || {};
      const colorNode = table.colors && table.colors[safeColor];
      const laceNode = colorNode && colorNode[lace || ''];
      const lengthNode = laceNode && laceNode[String(length)];
      if (!lengthNode) {
        return null;
      }
      return lengthNode[frontalSize || ''];
    }

    getFullLacePrice(baseColorKey, lace, length, density) {
      const safeColor = baseColorKey || 'natural_color';
      const products = this.data.products || {};
      const table = products.full_lace || {};
      const colorNode = table.colors && table.colors[safeColor];
      const laceNode = colorNode && colorNode[lace || ''];
      const lengthNode = laceNode && laceNode[String(length)];
      if (!lengthNode) {
        return null;
      }
      return lengthNode[String(density)];
    }

    hasAnyFrontalOption(baseColorKey, lace, length) {
      if (!lace || !length) {
        return false;
      }
      const sizes = this.data.meta.frontals_sizes || [];
      return sizes.some((sizeOption) => isFiniteNumber(this.getFrontalPrice(baseColorKey, lace, length, sizeOption.id)));
    }

    hasAnyFullLaceDensity(baseColorKey, lace, length) {
      if (!lace || !length) {
        return false;
      }
      const densities = this.data.meta.densities || [];
      return densities.some((density) => isFiniteNumber(this.getFullLacePrice(baseColorKey, lace, length, String(density))));
    }

    getBundlesTierMarkup(quantity) {
      const qty = toInt(quantity, 1);
      if (qty >= 5) {
        return toNumber(this.settings.markupBundlesTier3, 1.35);
      }
      if (qty >= 3) {
        return toNumber(this.settings.markupBundlesTier2, 1.45);
      }
      return toNumber(this.settings.markupBundlesTier1, 1.55);
    }

    getFrontalsMarkup(baseColorKey) {
      if (baseColorKey === '613') {
        return toNumber(this.settings.markupFrontals613, 1.63);
      }
      return toNumber(this.settings.markupFrontalsNatural, 1.5);
    }

    getShippingFee(subtotal, productType) {
      const subtotalValue = Math.max(toNumber(subtotal, 0), 0);
      const tier1Threshold = Math.max(toNumber(this.settings.shippingTier1Threshold, 215), 0);
      const tier2Threshold = Math.max(toNumber(this.settings.shippingTier2Threshold, 440), tier1Threshold);
      const feeTier1 = Math.max(toNumber(this.settings.shippingFeeTier1, 42), 0);
      const feeTier2 = Math.max(toNumber(this.settings.shippingFeeTier2, 25), 0);

      if (subtotalValue < tier1Threshold) {
        return feeTier1;
      }

      if (subtotalValue < tier2Threshold) {
        return feeTier2;
      }

      return 0;
    }

    getShippingQualifyingSubtotal(subtotal, productType) {
      return Math.max(toNumber(subtotal, 0), 0);
    }

    getShippingExplanation(result) {
      const tier1Threshold = Math.max(toNumber(this.settings.shippingTier1Threshold, 215), 0);
      const tier2Threshold = Math.max(toNumber(this.settings.shippingTier2Threshold, 440), tier1Threshold);
      const feeTier1 = Math.max(toNumber(this.settings.shippingFeeTier1, 42), 0);
      const feeTier2 = Math.max(toNumber(this.settings.shippingFeeTier2, 25), 0);
      const hasReducedTier = tier2Threshold > tier1Threshold;
      const shippingSavings = Math.max(feeTier1 - feeTier2, 0);

      if (!result || !result.valid) {
        if (hasReducedTier) {
          const tier2Upper = Math.max(tier2Threshold - 1, tier1Threshold);
          return `Shipping tiers: under ${formatUsd(tier1Threshold)} = ${formatUsd(feeTier1)}, ${formatUsd(tier1Threshold)}-${formatUsd(tier2Upper)} = ${formatUsd(feeTier2)}, ${formatUsd(tier2Threshold)}+ = Free.`;
        }
        return `Shipping tiers: under ${formatUsd(tier1Threshold)} = ${formatUsd(feeTier1)}, ${formatUsd(tier1Threshold)}+ = Free.`;
      }

      const qualifyingSubtotal = result && result.valid
        ? this.getShippingQualifyingSubtotal(result.subtotal, result.productType)
        : 0;

      if (qualifyingSubtotal < tier1Threshold) {
        const gap = Math.max(tier1Threshold - qualifyingSubtotal, 0);
        if (!hasReducedTier) {
          return `Standard Shipping: ${formatUsd(feeTier1)}. Add ${formatUsd(gap)} to unlock FREE SHIPPING.`;
        }
        if (shippingSavings > 0) {
          return `Standard Shipping: ${formatUsd(feeTier1)}. Add ${formatUsd(gap)} to save ${formatUsd(shippingSavings)} on shipping!`;
        }
        return `Standard Shipping: ${formatUsd(feeTier1)}. Add ${formatUsd(gap)} to reach reduced shipping (${formatUsd(feeTier2)}).`;
      }

      if (hasReducedTier && qualifyingSubtotal < tier2Threshold) {
        const gap = Math.max(tier2Threshold - qualifyingSubtotal, 0);
        return `Great! Shipping reduced to ${formatUsd(feeTier2)}. Add ${formatUsd(gap)} to get FREE SHIPPING!`;
      }

      return "Congratulations! You've unlocked FREE SHIPPING!";
    }

    paintShippingInfo(result) {
      const message = this.getShippingExplanation(this.getShippingDisplayResult(result));
      if (this.elements.shippingStatus) {
        this.elements.shippingStatus.textContent = message;
      }
      if (this.elements.shippingNote) {
        this.elements.shippingNote.textContent = message;
      }
    }

    getShippingDisplayResult(result) {
      if (this.shoppingList.length) {
        const totals = this.getShoppingListTotals();
        return {
          valid: true,
          productType: null,
          subtotal: totals.qualifyingSubtotal,
          qualifyingSubtotal: totals.qualifyingSubtotal
        };
      }

      return result && result.valid ? result : null;
    }

    buildShoppingItem(result) {
      const subtotal = toNumber(result.subtotal, 0);
      return {
        id: `item_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
        selection: { ...this.state },
        productType: this.state.productType,
        productLabel: this.getProductTypeLabel(this.state.productType),
        selectedConstruction: this.state.constructionType,
        constructionPath: result.constructionPath,
        constructionLabel: result.constructionLabel || 'N/A',
        madeToOrder: result.constructionPath === 'integrated_mto_component',
        colorLabel: this.getColorLabel(this.state.color) || 'N/A',
        laceLabel: this.getLaceLabel(this.state.lace) || 'N/A',
        lengthLookupKey: this.state.length || null,
        lengthLabel: result.lengthLabel || 'N/A',
        frontalLabel: this.getFrontalSizeLabel(this.state.frontalSize) || 'N/A',
        densityLabel: this.state.density ? this.getDensityLabel(this.state.density, this.state.productType) : 'N/A',
        textureLabel: this.getTextureLabel(this.state.texture) || 'N/A',
        capTypeLabel: this.getCapTypeWhatsAppLabel(this.state.capType) || 'N/A',
        capSizeLabel: this.getCapSizeWhatsAppLabel(this.state.capSize) || 'N/A',
        quantity: result.quantity,
        unitPrice: toNumber(result.unitPrice, 0),
        colorFee: toNumber(result.colorFee, 0),
        textureFee: toNumber(result.textureFee, 0),
        customizationFee: toNumber(result.customizationFee, 0),
        bleachFee: toNumber(result.bleachFee, 0),
        subtotal,
        qualifyingSubtotal: toNumber(result.qualifyingSubtotal, 0),
        shippingFee: 0,
        totalPrice: subtotal
      };
    }

    handleAddToList() {
      if (!this.lastResult || !this.lastResult.valid) {
        this.setStatus('Complete required selections before adding to Order Summary.', true);
        return;
      }

      if (this.addedToShoppingList) {
        return;
      }

      const item = this.buildShoppingItem(this.lastResult);
      const editingIndex = this.shoppingList.findIndex(saved => saved.id === this.editingItemId);
      if (editingIndex >= 0) {
        item.id = this.editingItemId;
        this.shoppingList[editingIndex] = item;
      } else {
        this.shoppingList.push(item);
        this.editingItemId = item.id;
      }
      this.isShoppingOpen = true;
      this.addedToShoppingList = true;
      this.renderShoppingList();
      this.refresh();
      this.setStatus(editingIndex >= 0 ? 'Item updated in your order.' : 'Item added. You can edit it or add another item.', false);
      this.root.dispatchEvent(new CustomEvent('calc:show-summary'));
    }

    editShoppingItem(itemId) {
      const item = this.shoppingList.find(saved => saved.id === itemId);
      if (!item?.selection) return;
      this.editingItemId = itemId;
      this.state = { ...item.selection };
      this.quantityExceededLimit = false;
      this.addedToShoppingList = true;
      this.activeAccordion = null;
      this.closeAllTooltips();
      this.renderShoppingList();
      this.refresh();
      this.root.dispatchEvent(new CustomEvent('calc:edit-item'));
    }

    startNewItem() {
      this.editingItemId = null;
      this.state.productType = this.getDefaultProductType();
      this.state.constructionType = null;
      this.state.color = null;
      this.state.lace = null;
      this.state.length = null;
      this.state.frontalSize = null;
      this.state.density = null;
      this.state.texture = null;
      this.state.capType = null;
      this.state.capSize = null;
      this.state.quantity = this.getNormalizedQuantity(1);
      this.quantityExceededLimit = false;
      this.applyQuoteUrlParameters();
      this.addedToShoppingList = false;
      this.activeAccordion = this.getInitialAccordion();
      this.closeAllTooltips();
      this.refresh();
    }

    clearShoppingList() {
      this.shoppingList = [];
      this.openShoppingItems.clear();
      this.addedToShoppingList = false;
      this.renderShoppingList();
      this.startNewItem();
      this.setStatus('Order Summary cleared.', false);
    }

    removeShoppingItem(itemId) {
      if (!itemId) {
        return;
      }
      this.shoppingList = this.shoppingList.filter((item) => item.id !== itemId);
      this.openShoppingItems.delete(itemId);
      this.renderShoppingList();
      if (this.editingItemId === itemId) {
        this.startNewItem();
      } else {
        this.updateActionButtons(this.lastResult);
        this.root.dispatchEvent(new CustomEvent('calc:updated'));
      }
    }

    toggleShoppingItem(itemId) {
      if (!itemId) {
        return;
      }
      if (this.openShoppingItems.has(itemId)) {
        this.openShoppingItems.delete(itemId);
      } else {
        this.openShoppingItems.add(itemId);
      }
      this.syncShoppingItemPanels();
    }

    syncShoppingSection() {
      const hasShoppingItems = this.shoppingList.length > 0;
      if (this.root.querySelector('[data-calc-order-list]')) this.isShoppingOpen = hasShoppingItems;
      if (!hasShoppingItems) {
        this.isShoppingOpen = false;
      }

      const shoppingRoot = this.root.querySelector('[data-calc-shopping]');
      if (shoppingRoot) {
        shoppingRoot.classList.toggle('is-empty', !hasShoppingItems);
        shoppingRoot.classList.toggle('is-collapsed', !hasShoppingItems || !this.isShoppingOpen);
      }
      if (this.elements.shoppingToggle) {
        this.elements.shoppingToggle.disabled = !hasShoppingItems;
        this.elements.shoppingToggle.classList.toggle('is-disabled', !hasShoppingItems);
        this.elements.shoppingToggle.setAttribute('aria-expanded', hasShoppingItems && this.isShoppingOpen ? 'true' : 'false');
      }
      if (this.elements.shoppingBody) {
        this.setPanelOpen(this.elements.shoppingBody, hasShoppingItems && this.isShoppingOpen);
      }
      if (this.elements.listEmpty) {
        this.elements.listEmpty.hidden = true;
      }
      this.syncShoppingItemPanels();
    }

    syncShoppingItemPanels() {
      const itemNodes = this.root.querySelectorAll('[data-calc-list-item-id]');
      itemNodes.forEach((itemNode) => {
        const itemId = itemNode.getAttribute('data-calc-list-item-id');
        const isOpen = this.isShoppingOpen && !!itemId && this.openShoppingItems.has(itemId);
        itemNode.classList.toggle('is-open', isOpen);

        const toggle = itemId
          ? itemNode.querySelector(`[data-calc-item-toggle-id="${CSS.escape(itemId)}"]`)
          : null;
        const panel = itemId
          ? itemNode.querySelector(`[data-calc-item-panel-id="${CSS.escape(itemId)}"]`)
          : null;

        if (toggle) {
          toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          const label = toggle.querySelector('.es-calc__shopping-expand-label');
          if (label) {
            label.textContent = isOpen ? 'Hide details' : 'View details';
          }
        }
        if (panel) {
          this.setPanelOpen(panel, isOpen);
        }
      });
    }

    scrollToShoppingList() {
      const shoppingRoot = this.root.querySelector('[data-calc-shopping]');
      if (!shoppingRoot || typeof window === 'undefined') {
        return;
      }

      if (this.scrollAnimationFrameId) {
        window.cancelAnimationFrame(this.scrollAnimationFrameId);
        this.scrollAnimationFrameId = null;
      }

      const rect = shoppingRoot.getBoundingClientRect();
      const absoluteTop = rect.top + window.scrollY;
      const stickyOffset = Math.max(
        12,
        toNumber(getComputedStyle(this.root).getPropertyValue('--calc-shopping-sticky-height').replace('rem', ''), 0) * 16
      );
      const targetY = Math.max(absoluteTop - stickyOffset - 12, 0);
      const startY = window.scrollY || window.pageYOffset || 0;
      const distance = targetY - startY;

      if (Math.abs(distance) < 2) {
        window.scrollTo(0, targetY);
        return;
      }

      const durationMs = 700;
      const startTime = performance.now();
      const easeInOutQuint = (t) => (
        t < 0.5
          ? 16 * Math.pow(t, 5)
          : 1 - Math.pow(-2 * t + 2, 5) / 2
      );

      const step = (now) => {
        const elapsed = now - startTime;
        const progress = Math.min(elapsed / durationMs, 1);
        const eased = easeInOutQuint(progress);
        const nextY = startY + (distance * eased);

        window.scrollTo(0, nextY);

        if (progress < 1) {
          this.scrollAnimationFrameId = window.requestAnimationFrame(step);
          return;
        }

        window.scrollTo(0, targetY);
        this.scrollAnimationFrameId = null;
      };

      this.scrollAnimationFrameId = window.requestAnimationFrame(step);
    }

    getPaymentDiscounts() {
      const adjustment = toNumber(this.settings.globalDiscountAdjustment, 0);
      return {
        bank: clamp(5 + adjustment, 0, 90)
      };
    }

    getPaymentOptionTotals(baseTotal) {
      const base = Math.max(toNumber(baseTotal, 0), 0);
      const discounts = this.getPaymentDiscounts();

      return {
        paypal: Math.ceil(base),
        bank: Math.ceil(base * (1 - (discounts.bank / 100))),
        discounts
      };
    }

    updatePaymentOptions(baseTotal) {
      if (!this.elements.paymentButtons.length) {
        return;
      }

      const hasBaseTotal = Number.isFinite(baseTotal);
      const optionTotals = hasBaseTotal ? this.getPaymentOptionTotals(baseTotal) : null;
      const discounts = optionTotals ? optionTotals.discounts : this.getPaymentDiscounts();

      const labelText = {
        paypal: 'PayPal',
        bank: `Bank transfer −${formatPercent(discounts.bank)}%`
      };

      Object.keys(this.elements.paymentLabels).forEach((optionKey) => {
        (this.elements.paymentLabels[optionKey] || []).forEach((node) => {
          node.textContent = labelText[optionKey];
        });
      });

      Object.keys(this.elements.paymentPrices).forEach((optionKey) => {
        const value = hasBaseTotal ? formatUsd(optionTotals[optionKey]) : '--';
        (this.elements.paymentPrices[optionKey] || []).forEach((node) => {
          node.textContent = value;
        });
      });
    }

    getDisplayedTotal(baseTotal) {
      if (!Number.isFinite(baseTotal)) {
        return null;
      }
      const optionTotals = this.getPaymentOptionTotals(baseTotal);
      return optionTotals.paypal;
    }

    syncHeaderTotal(result) {
      if (!this.elements.totals.length) {
        return;
      }

      const orderTotals = window.EverSilkyOrderPricing.getTotals(this, result);
      window.EverSilkyOrderPricing.render(this.root, orderTotals);
      const baseTotalValue = orderTotals ? orderTotals.finalCost : null;

      this.updatePaymentOptions(baseTotalValue);
      const nextTotalValue = this.getDisplayedTotal(baseTotalValue);

      if (nextTotalValue === null) {
        if (this.priceAnimationFrameId) {
          window.cancelAnimationFrame(this.priceAnimationFrameId);
          this.priceAnimationFrameId = null;
        }
        this.elements.totals.forEach((node) => {
          node.textContent = '--';
        });
        this.lastRenderedTotal = null;
        return;
      }

      // Show the actual estimate immediately; rolling intermediate prices are misleading.
      this.elements.totals.forEach((node) => {
        node.textContent = formatUsd(nextTotalValue);
      });

      this.lastRenderedTotal = nextTotalValue;
    }

    getShoppingListTotals() {
      if (!this.shoppingList.length) {
        return { subtotal: 0, qualifyingSubtotal: 0, shipping: 0, total: 0 };
      }

      const subtotal = this.shoppingList.reduce((acc, item) => acc + toNumber(item.subtotal, 0), 0);
      const qualifyingSubtotal = this.shoppingList.reduce((acc, item) => acc + toNumber(item.qualifyingSubtotal, 0), 0);
      const shipping = this.getShippingFee(qualifyingSubtotal, null);
      const total = subtotal + shipping;

      return {
        subtotal,
        qualifyingSubtotal,
        shipping,
        total
      };
    }

    renderShoppingList() {
      const wrap = this.elements.listWrap;
      if (!wrap) {
        return;
      }

      const validItemIds = new Set(this.shoppingList.map((item) => item.id));
      this.openShoppingItems.forEach((itemId) => {
        if (!validItemIds.has(itemId)) {
          this.openShoppingItems.delete(itemId);
        }
      });

      if (this.elements.listCount) {
        this.elements.listCount.textContent = String(this.shoppingList.length);
      }

      if (!this.shoppingList.length) {
        this.isShoppingOpen = false;
        wrap.innerHTML = '';
        if (this.elements.listEmpty) {
          this.elements.listEmpty.hidden = true;
        }
        if (this.elements.clearList) {
          this.elements.clearList.disabled = true;
        }
        if (this.elements.listSubtotal) {
          this.elements.listSubtotal.textContent = formatUsd(0);
        }
        if (this.elements.listShipping) {
          this.elements.listShipping.textContent = formatUsd(0);
        }
        if (this.elements.listTotal) {
          this.elements.listTotal.textContent = formatUsd(0);
        }
        this.paintShippingInfo(this.lastResult);
        this.syncHeaderTotal(this.lastResult);
        this.syncShoppingSection();
        return;
      }

      if (this.elements.listEmpty) {
        this.elements.listEmpty.hidden = true;
      }
      if (this.elements.clearList) {
        this.elements.clearList.disabled = false;
      }

      wrap.innerHTML = this.shoppingList
        .map((item, index) => {
          const itemTotalLabel = formatUsd(item.subtotal);
          const itemOpen = this.openShoppingItems.has(item.id);
          const expandLabel = itemOpen ? 'Hide details' : 'View details';
          const textureFeeValue = toNumber(item.textureFee, 0);
          const customizationFeeValue = toNumber(item.customizationFee, 0);
          const bleachFeeValue = toNumber(item.bleachFee, 0);
          const textureFee = textureFeeValue ? formatUsd(textureFeeValue) : 'Free ($0)';
          const customizationFee = customizationFeeValue ? formatUsd(customizationFeeValue) : 'Free ($0)';
          const bleachFee = bleachFeeValue ? formatUsd(bleachFeeValue) : 'Free ($0)';
          const panelId = `calc-item-panel-${item.id}`;
          return `
            <div class="es-calc__shopping-item ${itemOpen ? 'is-open' : ''}" data-calc-list-item-id="${item.id}">
              <div class="es-calc__shopping-item-head">
                <h4 class="es-calc__shopping-item-title">${index + 1}. ${escapeHtml(item.productLabel)}</h4>
                <strong class="es-calc__shopping-item-price">${itemTotalLabel}</strong>
              </div>
              <p class="es-calc__shopping-item-overview">${escapeHtml([item.lengthLabel, item.textureLabel, `Qty ${item.quantity}`].join(' · '))}</p>
              <div class="es-calc__shopping-item-actions">
                <button class="es-calc__shopping-item-toggle" type="button" data-calc-item-toggle-id="${item.id}" aria-controls="${panelId}" aria-expanded="${itemOpen ? 'true' : 'false'}">
                  <span class="es-calc__shopping-expand-label">${expandLabel}</span>
                </button>
                <button type="button" class="es-text-link" data-calc-edit-list-id="${item.id}" aria-label="Edit item ${index + 1}">Edit</button>
                <button class="es-calc__shopping-remove" type="button" data-calc-remove-list-id="${item.id}" aria-label="Remove item ${index + 1}">Remove</button>
              </div>
              <div id="${panelId}" class="es-calc__shopping-item-panel" data-calc-item-panel-id="${item.id}" aria-hidden="${itemOpen ? 'false' : 'true'}">
                <p class="es-calc__shopping-item-meta">Product Type: ${escapeHtml(item.productLabel)}</p>
                ${item.constructionLabel && item.constructionLabel !== 'N/A'
                  ? `<p class="es-calc__shopping-item-meta">Construction Type: ${escapeHtml(item.constructionLabel)}</p>`
                  : ''}
                <p class="es-calc__shopping-item-meta">Color: ${escapeHtml(item.colorLabel)}</p>
                <p class="es-calc__shopping-item-meta">Lace: ${escapeHtml(item.laceLabel)}</p>
                <p class="es-calc__shopping-item-meta">Wig Length: ${escapeHtml(item.lengthLabel)}</p>
                <p class="es-calc__shopping-item-meta">Frontals & Closures: ${escapeHtml(item.frontalLabel)}</p>
                <p class="es-calc__shopping-item-meta">Density: ${escapeHtml(item.densityLabel)}</p>
                <p class="es-calc__shopping-item-meta">Texture: ${escapeHtml(item.textureLabel)}</p>
                <p class="es-calc__shopping-item-meta">Installation Method: ${escapeHtml(item.capTypeLabel || 'N/A')}</p>
                <p class="es-calc__shopping-item-meta">Cap Size: ${escapeHtml(item.capSizeLabel || 'N/A')}</p>
                <p class="es-calc__shopping-item-meta">Customization Fee: ${escapeHtml(customizationFee)} | Bleach-Knot Fee: ${escapeHtml(bleachFee)}</p>
                <p class="es-calc__shopping-item-meta">Texture Fee: ${escapeHtml(textureFee)}</p>
              </div>
            </div>
          `;
        })
        .join('');

      const totals = this.getShoppingListTotals();
      if (this.elements.listSubtotal) {
        this.elements.listSubtotal.textContent = formatUsd(totals.subtotal);
      }
      if (this.elements.listShipping) {
        this.elements.listShipping.textContent = formatUsd(totals.shipping);
      }
      if (this.elements.listTotal) {
        this.elements.listTotal.textContent = formatUsd(totals.total);
      }
      this.paintShippingInfo(this.lastResult);
      this.syncHeaderTotal(this.lastResult);
      this.syncShoppingSection();
    }

    calculate() {
      const productType = this.state.productType;
      const baseColorKey = this.getBaseColorKey();
      const length = this.state.length;
      const lace = this.state.lace;
      const frontalSize = this.state.frontalSize;
      const density = this.state.density;
      const quantity = this.getNormalizedQuantity(this.state.quantity);
      const exchangeRate = toNumber(this.settings.exchangeRate, 6.92);
      const requiredFields = this.getRequiredFields(productType);
      const missingField = requiredFields.find((field) => field !== 'product_type' && !this.getStateByField(field));

      if (!productType || missingField) {
        return { valid: false, reason: 'Please finish all required selections.' };
      }

      const disallowed = requiredFields.find(field => {
        const allowed = this.getAllowedValues(field);
        return allowed && !allowed.has(String(this.getStateByField(field)));
      });
      if (disallowed) return { valid: false, reason: 'This combination is not available for this style. Please choose another option or chat with us.' };

      let unitPrice = null;
      let baseCny = null;
      let formula = '';
      let markupUsed = null;
      let constructionPath = null;

      if (productType === 'custom_bundle_wig') {
        if (!this.state.constructionType || !lace || !frontalSize || !density) {
          return { valid: false, reason: 'Custom Lace Wig requires construction type, lace, frontal size, and density.' };
        }
        if (this.isIntegratedSelection() && lace !== 'hd_lace') {
          return { valid: false, reason: 'Integrated One-Piece Construction is available in HD Lace only.' };
        }

        constructionPath = this.getConstructionPath();
        if (!constructionPath) {
          return { valid: false, reason: 'Selected Integrated One-Piece combination is not available.' };
        }
        if (constructionPath === 'integrated_mto_component' && (baseColorKey !== '613' || frontalSize === '13x6')) {
          return { valid: false, reason: 'Selected Integrated One-Piece combination is not available.' };
        }
        if (constructionPath === 'integrated_flat') {
          const integratedCny = this.getIntegratedPrice(baseColorKey, frontalSize, length, density);
          if (!isFiniteNumber(integratedCny)) {
            return { valid: false, reason: 'Selected Integrated One-Piece combination is not available.' };
          }
          const integratedMarkup = toNumber(this.settings.markupIntegrated, 1.2);
          unitPrice = Math.round((integratedCny / exchangeRate) * integratedMarkup);
          baseCny = integratedCny;
          markupUsed = integratedMarkup;
          formula = `round((Integrated_CNY / RATE) * ${integratedMarkup.toFixed(2)})`;
        } else {
          const componentLength = this.getCustomWigFrontalLookupLength(length);
          // The product/UI remains HD-only. The silent MTO fallback deliberately
          // uses the configured Assembled component cost basis (client $96 case).
          const componentLace = constructionPath === 'integrated_mto_component' ? this.getMtoComponentLaceKey() : lace;
          const bundleCny = this.getHairBundlePrice(baseColorKey, componentLength);
          const frontalCny = this.getFrontalPrice(baseColorKey, componentLace, componentLength, frontalSize);
          const bundleQty = this.getDensityBundleQty(density);

          if (!isFiniteNumber(bundleCny) || !isFiniteNumber(frontalCny) || !bundleQty) {
            return { valid: false, reason: 'Selected combination is not available.' };
          }

          const markupBundle = toNumber(this.settings.markupCustomWig, 1.4);
          const markupFrontal = 1.55;
          const bundlePartUsd = (bundleCny / exchangeRate) * markupBundle * bundleQty;
          const frontalPartUsd = (frontalCny / exchangeRate) * markupFrontal;
          unitPrice = Math.round(bundlePartUsd + frontalPartUsd);
          baseCny = (bundleCny * bundleQty) + frontalCny;
          markupUsed = markupBundle;
          formula = `round((Bundle_CNY[${componentLength}"] / RATE * ${markupBundle.toFixed(2)} * Bundle_Qty) + (Frontal_CNY[${componentLength}"] / RATE * ${markupFrontal.toFixed(2)}))`;
        }
      }

      if (productType === 'hair_bundles_only') {
        const allowedColors = new Set((((this.data.products || {}).hair_bundles_only || {}).available_colors || []));
        if (allowedColors.size && !allowedColors.has(this.state.color)) {
          return { valid: false, reason: 'Hair Bundles Only is available in Natural and Dark Solid colors.' };
        }
        const bundleCny = this.getHairBundlePrice(baseColorKey, length);
        if (!isFiniteNumber(bundleCny)) {
          return { valid: false, reason: 'Selected length is not available.' };
        }

        const tierMarkup = this.getBundlesTierMarkup(quantity);
        unitPrice = Math.ceil((bundleCny / exchangeRate) * tierMarkup);
        baseCny = bundleCny;
        markupUsed = tierMarkup;
        formula = 'ceil((CNY / RATE) * TierMarkup)';
      }

      if (productType === 'frontals_only') {
        if (!lace || !frontalSize) {
          return { valid: false, reason: 'Frontals & Closures requires lace and frontal size.' };
        }

        const frontalCny = this.getFrontalPrice(baseColorKey, lace, length, frontalSize);
        if (!isFiniteNumber(frontalCny)) {
          return { valid: false, reason: 'Selected frontal combination is not available.' };
        }

        const frontalMarkup = this.getFrontalsMarkup(baseColorKey);
        unitPrice = Math.ceil((frontalCny / exchangeRate) * frontalMarkup);
        baseCny = frontalCny;
        markupUsed = frontalMarkup;
        formula = 'ceil((CNY / RATE) * Markup_Frontals)';
      }

      if (productType === 'full_lace') {
        if (!lace || !density) {
          return { valid: false, reason: 'Full Lace Wig requires lace and density.' };
        }

        const fullLaceCny = this.getFullLacePrice(baseColorKey, lace, length, density);
        if (!isFiniteNumber(fullLaceCny)) {
          return { valid: false, reason: 'Selected full lace combination is not available.' };
        }

        const fullLaceMarkup = toNumber(this.settings.markupFullLace, 1.7);
        unitPrice = Math.ceil((fullLaceCny / exchangeRate) * fullLaceMarkup);
        baseCny = fullLaceCny;
        markupUsed = fullLaceMarkup;
        formula = `ceil((CNY / RATE) * ${fullLaceMarkup.toFixed(2)})`;
      }

      if (!isFiniteNumber(unitPrice)) {
        return { valid: false, reason: 'Unable to calculate price for selected options.' };
      }

      const colorFee = this.getColorFee();
      const textureFee = this.getTextureFee();
      const customizationFee = this.getServiceFee();
      const bleachFee = this.getBleachFee();
      const unitTotal = unitPrice + customizationFee + bleachFee + colorFee + textureFee;
      const feeFormula = formula ? `${formula} + CustomizationFee + BleachFee + DyeFee + TextureFee` : formula;
      const subtotal = unitTotal * quantity;
      const qualifyingSubtotal = this.getShippingQualifyingSubtotal(subtotal, productType);
      const shippingFee = this.getShippingFee(subtotal, productType);
      const totalPrice = subtotal + shippingFee;

      return {
        valid: true,
        unitPrice: unitTotal,
        colorFee,
        textureFee,
        customizationFee,
        bleachFee,
        subtotal,
        qualifyingSubtotal,
        shippingFee,
        totalPrice,
        quantity,
        baseCny,
        markupUsed,
        productType,
        constructionPath,
        constructionLabel: this.getConstructionLabel(constructionPath),
        lengthLabel: this.getDisplayLengthLabel(length),
        formula: feeFormula
      };
    }

    paintResult(result) {
      if (!this.elements.total) {
        return;
      }

      if (!result.valid) {
        this.syncHeaderTotal(result);
        if (this.elements.summary) {
          this.elements.summary.innerHTML = '<strong>Complete required selections to calculate price.</strong>';
        }
        if (this.elements.formula) {
          this.elements.formula.textContent = '--';
        }
        this.paintShippingInfo(null);
        this.setStatus(
          result.reason || 'Please select options to get a price.',
          result.reason ? !/^Please finish all required selections/.test(result.reason) : false
        );
        return;
      }

      const productLabel = this.getProductTypeLabel(this.state.productType);
      const colorLabel = this.getColorLabel(this.state.color);
      const laceLabel = this.getLaceLabel(this.state.lace);
      const textureLabel = this.getTextureLabel(this.state.texture);
      const densityLabel = this.state.density ? this.getDensityLabel(this.state.density, this.state.productType) : 'N/A';
      const frontalLabel = this.getFrontalSizeLabel(this.state.frontalSize);
      const lengthLabel = result.lengthLabel || 'N/A';
      const constructionLabel = result.constructionLabel && result.constructionLabel !== 'N/A'
        ? result.constructionLabel
        : '';

      this.syncHeaderTotal(result);
      if (this.elements.formula) {
        this.elements.formula.textContent = result.formula;
      }
      this.paintShippingInfo(result);

      if (this.elements.summary) {
        this.elements.summary.innerHTML = [
          `<span><strong>${productLabel}</strong></span>`,
          constructionLabel ? `<span>${constructionLabel}</span>` : '',
          `<span>${colorLabel || 'N/A'} • ${lengthLabel} • ${textureLabel || 'N/A'}</span>`,
          `<span>Unit ${formatUsd(result.unitPrice)} • Qty ${result.quantity} • Subtotal ${formatUsd(result.subtotal)}</span>`,
          `<span><strong>Total: ${formatUsd(result.totalPrice)}</strong></span>`
        ].filter(Boolean).join('');
      }

      this.setStatus(
        `${productLabel} • ${lengthLabel} • Qty ${result.quantity}`,
        false
      );
    }

    animateTotalPrice(fromValue, toValue) {
      if (!this.elements.totals.length) {
        return;
      }

      if (this.priceAnimationFrameId) {
        window.cancelAnimationFrame(this.priceAnimationFrameId);
        this.priceAnimationFrameId = null;
      }

      const startValue = toNumber(fromValue, 0);
      const endValue = toNumber(toValue, 0);
      const durationMs = 400;
      const startTime = performance.now();
      const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

      const step = (now) => {
        const elapsed = now - startTime;
        const progress = Math.min(elapsed / durationMs, 1);
        const eased = easeOutCubic(progress);
        const current = Math.round(startValue + ((endValue - startValue) * eased));
        this.elements.totals.forEach((node) => {
          node.textContent = formatUsd(current);
        });

        if (progress < 1) {
          this.priceAnimationFrameId = window.requestAnimationFrame(step);
          return;
        }

        this.elements.totals.forEach((node) => {
          node.textContent = formatUsd(endValue);
        });
        this.priceAnimationFrameId = null;
      };

      this.priceAnimationFrameId = window.requestAnimationFrame(step);
    }

    updateActionButtons(result) {
      const canCompute = !!(result && result.valid);
      const hasShoppingItems = this.shoppingList.length > 0;
      const hasPhone = normalizePhone(this.settings.whatsappPhone).length > 0;
      const showAddedState = this.addedToShoppingList;

      if (this.elements.addToList) {
        const disableAddToList = !canCompute || showAddedState;
        this.elements.addToList.disabled = disableAddToList;
        this.elements.addToList.classList.toggle('is-disabled', disableAddToList);
        this.elements.addToList.classList.toggle('is-added', showAddedState);
        this.elements.addToList.textContent = showAddedState
          ? 'Added to Order Summary'
          : (this.editingItemId ? 'Update item' : 'Add Item to Order Summary');
        this.elements.addToList.title = showAddedState
          ? 'Change an option to update this item, or choose Add another item.'
          : (disableAddToList ? 'Complete required selections first.' : '');
      }

      if (this.elements.whatsapp) {
        const disableWhatsapp = !hasPhone || (!canCompute && !hasShoppingItems);
        this.elements.whatsapp.classList.toggle('is-disabled', disableWhatsapp);
        this.elements.whatsapp.setAttribute('aria-disabled', disableWhatsapp ? 'true' : 'false');
        this.elements.whatsapp.setAttribute('tabindex', disableWhatsapp ? '-1' : '0');

        const url = this.buildWhatsAppUrl();
        if (url && !disableWhatsapp) {
          this.elements.whatsapp.setAttribute('href', url);
        } else {
          this.elements.whatsapp.removeAttribute('href');
        }
      }
    }

    getProductTypeLabel(id) {
      const option = getOptionById(this.data.meta.product_types || [], id);
      return option ? option.label : id;
    }

    getDisplayColorLabel(id) {
      const option = getOptionById(this.data.color_options || [], id);
      if (!option) {
        return id;
      }

      if (id === 'natural_color') {
        return 'Natural';
      }
      if (id === '613') {
        return '#613';
      }

      const normalized = String(option.label || id)
        .replace(/_/g, ' ')
        .replace(/\s*\(Refer to the Color Showcase below\)\s*/i, '')
        .trim();

      return normalized || id;
    }

    getColorLabel(id) {
      return this.getDisplayColorLabel(id);
    }

    getLaceLabel(id) {
      const option = getOptionById(this.data.meta.lace_types || [], id);
      return option ? option.label : id;
    }

    getTextureLabel(id) {
      const option = getOptionById(this.data.texture_options || [], id);
      return option ? option.label : id;
    }

    getCapTypeOption(id) {
      const meta = this.data.meta || {};
      return getOptionById(meta.cap_types || [], id);
    }

    getCapSizeOption(id) {
      const meta = this.data.meta || {};
      return getOptionById(meta.cap_sizes || [], id);
    }

    getCapTypeLabel(id) {
      const option = this.getCapTypeOption(id);
      return option ? option.label : id;
    }

    getCapSizeLabel(id) {
      const option = this.getCapSizeOption(id);
      return option ? option.label : id;
    }

    getCapTypeWhatsAppLabel(id) {
      const option = this.getCapTypeOption(id);
      return option ? (option.whatsapp_label || option.label) : id;
    }

    getCapSizeWhatsAppLabel(id) {
      const option = this.getCapSizeOption(id);
      return option ? (option.whatsapp_label || option.label) : id;
    }

    getFrontalSizeLabel(id) {
      const option = getOptionById(this.data.meta.frontals_sizes || [], id);
      return option ? option.label : id;
    }

    buildWhatsAppItemLines(item, index) {
      const lines = [
        `Item ${index + 1}: ${formatWhatsAppUsd(item.subtotal)} = ${normalizeWhatsAppLabel(item.productLabel)} - ${formatWhatsAppLength(item.lengthLabel, 'headline')} (Qty: ${item.quantity})`,
        `• Product Type: ${normalizeWhatsAppLabel(item.productLabel)}`
      ];
      if (item.constructionLabel && item.constructionLabel !== 'N/A') {
        lines.push(`• Construction Type: ${normalizeWhatsAppLabel(item.constructionLabel)}`);
      }
      lines.push(
        `• Color: ${normalizeWhatsAppColorLabel(item.colorLabel)}`,
        `• Lace: ${normalizeWhatsAppLabel(item.laceLabel)}`,
        `• Wig Length: ${formatWhatsAppLength(item.lengthLabel, 'detail')}`,
        `• Frontals & Closures: ${normalizeWhatsAppLabel(item.frontalLabel)}`,
        `• Density: ${normalizeWhatsAppLabel(item.densityLabel)}`,
        `• Texture: ${normalizeWhatsAppLabel(item.textureLabel)}`,
        `• Installation Method: ${normalizeWhatsAppLabel(item.capTypeLabel)}`,
        `• Cap Size: ${normalizeWhatsAppLabel(item.capSizeLabel)}`
      );
      return lines;
    }

    setStatus(message, isError) {
      if (!this.elements.statuses.length) {
        return;
      }
      this.elements.statuses.forEach((node) => {
        node.textContent = message || '';
        node.classList.toggle('is-error', !!isError);
      });
    }

    buildOrderSummary() {
      const result = this.lastResult;
      const hasShoppingItems = this.shoppingList.length > 0;
      const separator = getWhatsAppSeparator();
      if (!hasShoppingItems && (!result || !result.valid)) {
        return '';
      }

      const lines = [];
      if (this.settings.pageType === 'product' && this.settings.productTitle) lines.push(`Style: ${this.settings.productTitle}`);
      lines.push('New Order from Calculator:');

      if (hasShoppingItems) {
        this.shoppingList.forEach((item, index) => {
          lines.push(...this.buildWhatsAppItemLines(item, index));
          lines.push(separator);
        });
      } else {
        lines.push(...this.buildWhatsAppItemLines({
          subtotal: result.subtotal,
          productLabel: this.getProductTypeLabel(this.state.productType),
          constructionLabel: result.constructionLabel || 'N/A',
          colorLabel: this.getColorLabel(this.state.color),
          laceLabel: this.getLaceLabel(this.state.lace) || 'N/A',
          lengthLabel: result.lengthLabel || 'N/A',
          frontalLabel: this.getFrontalSizeLabel(this.state.frontalSize) || 'N/A',
          densityLabel: this.state.density ? this.getDensityLabel(this.state.density, this.state.productType) : 'N/A',
          textureLabel: this.getTextureLabel(this.state.texture) || 'N/A',
          capTypeLabel: this.getCapTypeWhatsAppLabel(this.state.capType) || 'N/A',
          capSizeLabel: this.getCapSizeWhatsAppLabel(this.state.capSize) || 'N/A',
          quantity: result.quantity
        }, 0));
        lines.push(separator);

      }

      lines.push(...window.EverSilkyOrderPricing.summaryLines(this, separator));

      return lines.join('\n');
    }

    buildWhatsAppUrl() {
      const phone = normalizePhone(this.settings.whatsappPhone);
      const summary = this.buildOrderSummary();
      return phone && summary ? `https://wa.me/${encodeURIComponent(phone)}?text=${encodeURIComponent(summary)}` : '';
    }

  }

  window.PricingEngine = PricingEngine;

  function getSectionSettings(sectionId) {
    const globalSettings = window.CalcSettings || {};
    if (globalSettings[sectionId]) {
      return globalSettings[sectionId];
    }
    if (globalSettings && typeof globalSettings === 'object' && Object.prototype.hasOwnProperty.call(globalSettings, 'dataUrl')) {
      return globalSettings;
    }
    return {};
  }

  function initGuideLightbox(root) {
    if (!root || root.dataset.guideLightboxReady === 'true' || typeof document === 'undefined') {
      return;
    }

    const sectionId = root.dataset.sectionId || '';
    root.dataset.guideLightboxReady = 'true';

    if (!sectionId) {
      return;
    }

    const triggers = Array.from(document.querySelectorAll('[data-calc-guide-trigger]'))
      .filter((node) => node.dataset.sectionId === sectionId);
    const lightbox = Array.from(document.querySelectorAll('[data-calc-guide-lightbox]'))
      .find((node) => node.dataset.sectionId === sectionId);

    if (!triggers.length || !lightbox) {
      return;
    }

    const image = lightbox.querySelector('[data-calc-guide-lightbox-image]');
    const caption = lightbox.querySelector('[data-calc-guide-lightbox-caption]');
    const closeButton = lightbox.querySelector('[data-calc-guide-lightbox-close]');
    const transitionDurationMs = 180;
    const imageCache = new Map();
    let activeTrigger = null;
    let closeTimerId = null;
    let requestId = 0;

    const preloadImage = (src) => {
      if (!src || typeof Image === 'undefined') {
        return Promise.resolve(src);
      }

      if (imageCache.has(src)) {
        return imageCache.get(src);
      }

      const pending = new Promise((resolve, reject) => {
        const preloadedImage = new Image();
        preloadedImage.onload = () => resolve(src);
        preloadedImage.onerror = reject;
        preloadedImage.src = src;
      });

      imageCache.set(src, pending);
      return pending;
    };

    const closeLightbox = () => {
      if (lightbox.hidden) {
        return;
      }

      requestId += 1;
      lightbox.classList.remove('is-open');
      document.body.classList.remove('es-calc-lightbox-open');
      lightbox.setAttribute('aria-hidden', 'true');

      if (closeTimerId) {
        window.clearTimeout(closeTimerId);
      }

      closeTimerId = window.setTimeout(() => {
        if (lightbox.classList.contains('is-open')) {
          return;
        }

        lightbox.hidden = true;

        if (image) {
          image.removeAttribute('src');
          image.removeAttribute('alt');
          image.classList.remove('is-loading');
        }

        if (caption) {
          caption.textContent = '';
          caption.hidden = true;
        }

        if (activeTrigger && typeof activeTrigger.focus === 'function') {
          activeTrigger.focus();
        }

        activeTrigger = null;
      }, transitionDurationMs);
    };

    const openLightbox = (trigger) => {
      if (!trigger || !image) {
        return;
      }

      const highResSrc = trigger.dataset.calcGuideSrc || '';
      const previewSrc = trigger.dataset.calcGuidePreviewSrc
        || trigger.querySelector('img')?.currentSrc
        || trigger.querySelector('img')?.src
        || highResSrc;

      if (!previewSrc && !highResSrc) {
        return;
      }

      requestId += 1;
      const currentRequestId = requestId;
      activeTrigger = trigger;

      if (closeTimerId) {
        window.clearTimeout(closeTimerId);
        closeTimerId = null;
      }

      image.src = previewSrc || highResSrc;
      image.alt = trigger.dataset.calcGuideAlt || '';
      image.classList.toggle('is-loading', !!highResSrc && highResSrc !== previewSrc);

      if (caption) {
        const captionText = String(trigger.dataset.calcGuideCaption || '').trim();
        caption.textContent = captionText;
        caption.hidden = !captionText;
      }

      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('es-calc-lightbox-open');
      window.requestAnimationFrame(() => {
        lightbox.classList.add('is-open');
      });

      if (closeButton && typeof closeButton.focus === 'function') {
        closeButton.focus();
      }

      if (!highResSrc || highResSrc === previewSrc) {
        image.classList.remove('is-loading');
        return;
      }

      preloadImage(highResSrc)
        .then(() => {
          if (currentRequestId !== requestId || lightbox.hidden) {
            return;
          }
          image.src = highResSrc;
          image.classList.remove('is-loading');
        })
        .catch(() => {
          if (currentRequestId !== requestId || lightbox.hidden) {
            return;
          }
          image.classList.remove('is-loading');
        });
    };

    triggers.forEach((trigger) => {
      const warmLightbox = () => {
        const src = trigger.dataset.calcGuideSrc || '';
        preloadImage(src).catch(() => {});
      };

      trigger.addEventListener('mouseenter', warmLightbox);
      trigger.addEventListener('focus', warmLightbox);
      trigger.addEventListener('touchstart', warmLightbox, { passive: true });
      trigger.addEventListener('click', () => {
        openLightbox(trigger);
      });
    });

    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox || event.target.closest('[data-calc-guide-lightbox-close]')) {
        closeLightbox();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !lightbox.hidden) {
        closeLightbox();
      }
    });
  }

  function initUserGuideLightbox(root) {
    if (!root || root.dataset.userGuideLightboxReady === 'true' || typeof document === 'undefined') {
      return;
    }

    const sectionId = root.dataset.sectionId || '';
    root.dataset.userGuideLightboxReady = 'true';

    if (!sectionId) {
      return;
    }

    const trigger = Array.from(document.querySelectorAll('[data-calc-user-guide-trigger]'))
      .find((node) => node.dataset.sectionId === sectionId);
    const lightbox = Array.from(document.querySelectorAll('[data-calc-user-guide-lightbox]'))
      .find((node) => node.dataset.sectionId === sectionId);

    if (!trigger || !lightbox) {
      return;
    }

    const video = lightbox.querySelector('[data-calc-user-guide-video]');
    const closeButton = lightbox.querySelector('[data-calc-user-guide-close]');
    const transitionDurationMs = 180;
    let activeTrigger = null;
    let closeTimerId = null;

    const warmVideo = () => {
      if (!video) {
        return;
      }

      video.preload = 'auto';
      if (typeof video.load === 'function' && video.readyState === 0) {
        video.load();
      }
    };

    const closeLightbox = () => {
      if (lightbox.hidden) {
        return;
      }

      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('es-calc-lightbox-open');

      if (video && typeof video.pause === 'function') {
        video.pause();
      }

      if (closeTimerId) {
        window.clearTimeout(closeTimerId);
      }

      closeTimerId = window.setTimeout(() => {
        if (lightbox.classList.contains('is-open')) {
          return;
        }

        lightbox.hidden = true;

        if (video) {
          try {
            video.currentTime = 0;
          } catch (error) {
            // Some mobile browsers prevent seeking until metadata is available.
          }
        }

        if (activeTrigger && typeof activeTrigger.focus === 'function') {
          activeTrigger.focus();
        }

        activeTrigger = null;
      }, transitionDurationMs);
    };

    const openLightbox = () => {
      activeTrigger = trigger;
      warmVideo();

      if (closeTimerId) {
        window.clearTimeout(closeTimerId);
        closeTimerId = null;
      }

      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('es-calc-lightbox-open');
      window.requestAnimationFrame(() => {
        lightbox.classList.add('is-open');
      });

      if (closeButton && typeof closeButton.focus === 'function') {
        closeButton.focus();
      }
    };

    trigger.addEventListener('mouseenter', warmVideo);
    trigger.addEventListener('focus', warmVideo);
    trigger.addEventListener('touchstart', warmVideo, { passive: true });
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      openLightbox();
    });

    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox || event.target.closest('[data-calc-user-guide-close]')) {
        closeLightbox();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !lightbox.hidden) {
        closeLightbox();
      }
    });
  }

  function initCalculator(root) {
    if (root.calcEngine) return;
    const sectionId = root.dataset.sectionId || '';
    const settings = getSectionSettings(sectionId);
    initGuideLightbox(root);
    initUserGuideLightbox(root);
    const engine = new PricingEngine(root, settings);
    root.calcEngine = engine;
    engine.init().then(() => root.dispatchEvent(new CustomEvent('calc:ready')));
  }

  function boot() {
    document.querySelectorAll('[data-es-calc-root]').forEach((root) => {
      initCalculator(root);
    });
  }

  document.addEventListener('shopify:section:load', boot);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
